import moment from 'moment';
import CryptoJS from 'crypto-js';
import { format, parse, Locale, isBefore, isValid, differenceInCalendarMonths, isEqual, addDays } from 'date-fns';
import { ja } from 'date-fns/locale';
import { SearchBranch } from '../external/AggregationApi';
import { ConditionItem } from '../external/Common';
import { MasterInfoState } from '../redux/reducers/MasterInfoReducer';
import { pendingViewColumns } from '../redux/reducers/NegotiationPendingReducer';
import { SearchConditionState } from '../redux/reducers/SearchConditionReducer';
import { RegistrationProduct } from '../../../crew/src/external/CustomerBundleRegistrationApi';
import { getReplacedStringByParams } from '../utils/StringUtil';
import { SmallCategory } from '../external/SalesManNameApi';
import { GASpotEventState } from '../component/organisms/NegotiationCountList';
import { DISPLAY_ITEM_ID as _DISPLAY_ITEM_ID } from '../redux/reducers/MasterInfoReducer/definitions/DisplayItemId';
import { uniqWith } from 'lodash';

/** モジュール */
export const MODULE = {
  /** クルーモジュール */
  CREW: 'crew',
  /** 代理店モジュール */
  AGENCY: 'agency',
  /** 営業モジュール */
  EMPLOYEE: 'employee',
  /** 顧客モジュール */
  CUSTOMER: 'customer',
};

/** Max with for iPad Air 4th and 5th generation (820x1180px screen size)  */
export const MAX_IPAD_WIDTH = 1181;

export const LINE_TYPE = {
  PERIOD: 'periodType',
  ACTION: 'actionType',
  PROB: 'contractAccuracyType',
  RESULT: 'negotiationResultType',
  PENDING: 'holdPeriodType',
};

export const TAB_TYPE = {
  PERIOD: 'period',
  ACTION: 'action',
  PROB: 'prob',
  RESULT: 'result',
  PENDING: 'pending',
};

export const STATUS_TYPE = {
  UNDER: '01',
  DONE: '02',
  PENDING: '03',
  NO_TYPE: '',
};
export const SCROLL_TARGET_TYPE = {
  NEGOTIATION: 'negotiation',
  PRODUCT: 'product',
  ACTION: 'action',
  /**
   * ご案内書類へスクロール
   */
  NEGOTIATION_PHOTO: 'nIdPhoto',
} as const;

export const commodityCategoryContractTypeList: string[][] = [
  ['smartphoneNew', 'HS(スマホ)/新規'],
  ['smartphoneTransfer', 'HS(スマホ)/番号移行'],
  ['smartphoneMnp', 'HS(スマホ)/MNP'],
  ['smartphoneChange', 'HS(スマホ)/機変'],
  ['smartphoneContrChg', 'HS(スマホ)/契約変更'],
  ['garakeiNew', 'HS(スマホ以外)/新規'],
  ['garakeiTransfer', 'HS(スマホ以外)/番号移行'],
  ['garakeiMnp', 'HS(スマホ以外)/MNP'],
  ['garakeiChange', 'HS(スマホ以外)/機変'],
  ['garakeiContrChg', 'HS(スマホ以外)/契約変更'],
  ['tabletNew', 'タブレット/新規'],
  ['tabletTransfer', 'タブレット/番号移行'],
  ['tabletMnp', 'タブレット/MNP'],
  ['tabletChange', 'タブレット/機変'],
  ['tabletContrChg', 'タブレット/契約変更'],
  ['otherNew', 'その他（モバイル）/新規'],
  ['otherTransfer', 'その他（モバイル）/番号移行'],
  ['otherMnp', 'その他（モバイル）/MNP'],
  ['otherChange', 'その他（モバイル）/機変'],
  ['otherContrChg', 'その他（モバイル）/契約変更'],
  ['hikariNew', 'ソフトバンク光/新規'],
  ['hikariDiverted', 'ソフトバンク光/転用'],
  ['hikariChange', 'ソフトバンク光/事業者変更'],
  ['hikariReuse', 'ソフトバンク光/光回線再利用'],
  ['hikariSrvChgAurora', 'ソフトバンク光/サービス変更（SB光＋）'],
  ['hikariSrvChgAir', 'ソフトバンク光/サービス変更（SB Air）'],
  ['hikariSrvChgBbisp', 'ソフトバンク光/サービス変更（BBISP）'],
  ['auroraNew', 'SoftBank 光＋/新規'],
  ['auroraSrvChgHikari', 'SoftBank 光＋/サービス変更（SB 光）'],
  ['auroraSrvChgAir', 'SoftBank 光＋/サービス変更（SB Air）'],
  ['auroraReUseHikari', 'SoftBank 光＋/光回線再利用（コラボ光）'],
  ['auroraSrvChgBbisp', 'SoftBank 光＋/サービス変更（BBISP）'],
  ['airNew', 'SBAir/新規'],
  ['airChange', 'SBAir/機変'],
  ['airSrvChgHikari', 'SBAir/サービス変更（SB 光）'],
  ['airSrvChgAurora', 'SBAir/サービス変更（SB光＋）'],
  ['denkiNew', 'おうちでんき/新規'],
  ['denwaNew', 'おうちのでんわ/新規'],
  ['simNew', 'SIM単体/新規'],
  ['simTransfer', 'SIM単体/番号移行'],
  ['simMnp', 'SIM単体/MNP'],
  ['simChange', 'SIM単体/機変'],
  ['simContrChg', 'SIM単体/契約変更'],
  ['dataBoxNew', 'あんしんデータボックス/新規'],
  ['basketLiveNew', 'バスケットLIVE/新規'],
  ['smartphoneSetSupportNew', '店頭スマホサポート（他社）/新規（定額加入／サポート利用）'],
];

/**
 * TODO: マスタ化したら削除
 */
export const commodityCategoryContractTypeMapping: {
  [key: string]: Array<SearchBranch>;
} = {
  '0101': [
    {
      branchConditionName: 'commodityCategoryType',
      specifiedCondition: ['01'],
    },
    {
      branchConditionName: 'mobileContractType',
      specifiedCondition: ['01'],
    },
  ],
  '0102': [
    {
      branchConditionName: 'commodityCategoryType',
      specifiedCondition: ['01'],
    },
    {
      branchConditionName: 'mobileContractType',
      specifiedCondition: ['02'],
    },
  ],
  '0103': [
    {
      branchConditionName: 'commodityCategoryType',
      specifiedCondition: ['01'],
    },
    {
      branchConditionName: 'mobileContractType',
      specifiedCondition: ['03'],
    },
  ],
  '0104': [
    {
      branchConditionName: 'commodityCategoryType',
      specifiedCondition: ['01'],
    },
    {
      branchConditionName: 'mobileContractType',
      specifiedCondition: ['04'],
    },
  ],
  '0105': [
    {
      branchConditionName: 'commodityCategoryType',
      specifiedCondition: ['01'],
    },
    {
      branchConditionName: 'mobileContractType',
      specifiedCondition: ['05'],
    },
  ],
  '0201': [
    {
      branchConditionName: 'commodityCategoryType',
      specifiedCondition: ['02'],
    },
    {
      branchConditionName: 'mobileContractType',
      specifiedCondition: ['01'],
    },
  ],
  '0202': [
    {
      branchConditionName: 'commodityCategoryType',
      specifiedCondition: ['02'],
    },
    {
      branchConditionName: 'mobileContractType',
      specifiedCondition: ['02'],
    },
  ],
  '0203': [
    {
      branchConditionName: 'commodityCategoryType',
      specifiedCondition: ['02'],
    },
    {
      branchConditionName: 'mobileContractType',
      specifiedCondition: ['03'],
    },
  ],
  '0204': [
    {
      branchConditionName: 'commodityCategoryType',
      specifiedCondition: ['02'],
    },
    {
      branchConditionName: 'mobileContractType',
      specifiedCondition: ['04'],
    },
  ],
  '0205': [
    {
      branchConditionName: 'commodityCategoryType',
      specifiedCondition: ['02'],
    },
    {
      branchConditionName: 'mobileContractType',
      specifiedCondition: ['05'],
    },
  ],
  '0301': [
    {
      branchConditionName: 'commodityCategoryType',
      specifiedCondition: ['03'],
    },
    {
      branchConditionName: 'mobileContractType',
      specifiedCondition: ['01'],
    },
  ],
  '0302': [
    {
      branchConditionName: 'commodityCategoryType',
      specifiedCondition: ['03'],
    },
    {
      branchConditionName: 'mobileContractType',
      specifiedCondition: ['02'],
    },
  ],
  '0303': [
    {
      branchConditionName: 'commodityCategoryType',
      specifiedCondition: ['03'],
    },
    {
      branchConditionName: 'mobileContractType',
      specifiedCondition: ['03'],
    },
  ],
  '0304': [
    {
      branchConditionName: 'commodityCategoryType',
      specifiedCondition: ['03'],
    },
    {
      branchConditionName: 'mobileContractType',
      specifiedCondition: ['04'],
    },
  ],
  '0305': [
    {
      branchConditionName: 'commodityCategoryType',
      specifiedCondition: ['03'],
    },
    {
      branchConditionName: 'mobileContractType',
      specifiedCondition: ['05'],
    },
  ],
  '0401': [
    {
      branchConditionName: 'commodityCategoryType',
      specifiedCondition: ['04'],
    },
    {
      branchConditionName: 'mobileContractType',
      specifiedCondition: ['01'],
    },
  ],
  '0402': [
    {
      branchConditionName: 'commodityCategoryType',
      specifiedCondition: ['04'],
    },
    {
      branchConditionName: 'mobileContractType',
      specifiedCondition: ['02'],
    },
  ],
  '0403': [
    {
      branchConditionName: 'commodityCategoryType',
      specifiedCondition: ['04'],
    },
    {
      branchConditionName: 'mobileContractType',
      specifiedCondition: ['03'],
    },
  ],
  '0404': [
    {
      branchConditionName: 'commodityCategoryType',
      specifiedCondition: ['04'],
    },
    {
      branchConditionName: 'mobileContractType',
      specifiedCondition: ['04'],
    },
  ],
  '0405': [
    {
      branchConditionName: 'commodityCategoryType',
      specifiedCondition: ['04'],
    },
    {
      branchConditionName: 'mobileContractType',
      specifiedCondition: ['05'],
    },
  ],
  '0501': [
    {
      branchConditionName: 'commodityCategoryType',
      specifiedCondition: ['05'],
    },
    {
      branchConditionName: 'sbHikariContractType',
      specifiedCondition: ['01'],
    },
  ],
  '0502': [
    {
      branchConditionName: 'commodityCategoryType',
      specifiedCondition: ['05'],
    },
    {
      branchConditionName: 'sbHikariContractType',
      specifiedCondition: ['02'],
    },
  ],
  '0503': [
    {
      branchConditionName: 'commodityCategoryType',
      specifiedCondition: ['05'],
    },
    {
      branchConditionName: 'sbHikariContractType',
      specifiedCondition: ['03'],
    },
  ],
  '0504': [
    {
      branchConditionName: 'commodityCategoryType',
      specifiedCondition: ['05'],
    },
    {
      branchConditionName: 'sbHikariContractType',
      specifiedCondition: ['04'],
    },
  ],
  '0505': [
    {
      branchConditionName: 'commodityCategoryType',
      specifiedCondition: ['05'],
    },
    {
      branchConditionName: 'sbHikariContractType',
      specifiedCondition: ['05'],
    },
  ],
  '0506': [
    {
      branchConditionName: 'commodityCategoryType',
      specifiedCondition: ['05'],
    },
    {
      branchConditionName: 'sbHikariContractType',
      specifiedCondition: ['06'],
    },
  ],
  '0507': [
    {
      branchConditionName: 'commodityCategoryType',
      specifiedCondition: ['05'],
    },
    {
      branchConditionName: 'sbHikariContractType',
      specifiedCondition: ['07'],
    },
  ],
  '0601': [
    {
      branchConditionName: 'commodityCategoryType',
      specifiedCondition: ['06'],
    },
    {
      branchConditionName: 'sbAirContractType',
      specifiedCondition: ['01'],
    },
  ],
  '0602': [
    {
      branchConditionName: 'commodityCategoryType',
      specifiedCondition: ['06'],
    },
    {
      branchConditionName: 'sbAirContractType',
      specifiedCondition: ['02'],
    },
  ],
  '0603': [
    {
      branchConditionName: 'commodityCategoryType',
      specifiedCondition: ['06'],
    },
    {
      branchConditionName: 'sbAirContractType',
      specifiedCondition: ['03'],
    },
  ],
  '0604': [
    {
      branchConditionName: 'commodityCategoryType',
      specifiedCondition: ['06'],
    },
    {
      branchConditionName: 'sbAirContractType',
      specifiedCondition: ['04'],
    },
  ],
  '0701': [
    {
      branchConditionName: 'commodityCategoryType',
      specifiedCondition: ['07'],
    },
    {
      branchConditionName: 'pwrContractType',
      specifiedCondition: ['01'],
    },
  ],
  '0801': [
    {
      branchConditionName: 'commodityCategoryType',
      specifiedCondition: ['08'],
    },
    {
      branchConditionName: 'landlinePhoneContractType',
      specifiedCondition: ['01'],
    },
  ],
  '0901': [
    {
      branchConditionName: 'commodityCategoryType',
      specifiedCondition: ['09'],
    },
    {
      branchConditionName: 'mobileContractType',
      specifiedCondition: ['01'],
    },
  ],
  '0902': [
    {
      branchConditionName: 'commodityCategoryType',
      specifiedCondition: ['09'],
    },
    {
      branchConditionName: 'mobileContractType',
      specifiedCondition: ['02'],
    },
  ],
  '0903': [
    {
      branchConditionName: 'commodityCategoryType',
      specifiedCondition: ['09'],
    },
    {
      branchConditionName: 'mobileContractType',
      specifiedCondition: ['03'],
    },
  ],
  '0904': [
    {
      branchConditionName: 'commodityCategoryType',
      specifiedCondition: ['09'],
    },
    {
      branchConditionName: 'mobileContractType',
      specifiedCondition: ['04'],
    },
  ],
  '0905': [
    {
      branchConditionName: 'commodityCategoryType',
      specifiedCondition: ['09'],
    },
    {
      branchConditionName: 'mobileContractType',
      specifiedCondition: ['05'],
    },
  ],
  '1001': [
    {
      branchConditionName: 'commodityCategoryType',
      specifiedCondition: ['10'],
    },
    {
      branchConditionName: 'dataBoxContractType',
      specifiedCondition: ['01'],
    },
  ],
  '1101': [
    {
      branchConditionName: 'commodityCategoryType',
      specifiedCondition: ['11'],
    },
    {
      branchConditionName: 'basketLiveContractType',
      specifiedCondition: ['01'],
    },
  ],
  '1205': [
    {
      branchConditionName: 'commodityCategoryType',
      specifiedCondition: ['12'],
    },
    {
      branchConditionName: 'smartphoneSetSupportContractType',
      specifiedCondition: ['05'],
    },
  ],
  '1301': [
    {
      branchConditionName: 'commodityCategoryType',
      specifiedCondition: ['13'],
    },
    {
      branchConditionName: 'auroraContractType',
      specifiedCondition: ['01'],
    },
  ],
  '1302': [
    {
      branchConditionName: 'commodityCategoryType',
      specifiedCondition: ['13'],
    },
    {
      branchConditionName: 'auroraContractType',
      specifiedCondition: ['02'],
    },
  ],
  '1303': [
    {
      branchConditionName: 'commodityCategoryType',
      specifiedCondition: ['13'],
    },
    {
      branchConditionName: 'auroraContractType',
      specifiedCondition: ['03'],
    },
  ],
  '1304': [
    {
      branchConditionName: 'commodityCategoryType',
      specifiedCondition: ['13'],
    },
    {
      branchConditionName: 'auroraContractType',
      specifiedCondition: ['04'],
    },
  ],
  '1305': [
    {
      branchConditionName: 'commodityCategoryType',
      specifiedCondition: ['13'],
    },
    {
      branchConditionName: 'auroraContractType',
      specifiedCondition: ['05'],
    },
  ],
};

/**
 * TODO: マスタ化したら削除
 */
export const negotiationStatusTypeMapping: {
  [key: string]: Array<SearchBranch>;
} = {
  '01': [
    {
      branchConditionName: 'negotiationProgressType',
      specifiedCondition: ['01', '00', '05'],
    },
  ],
  '02': [
    {
      branchConditionName: 'negotiationProgressType',
      specifiedCondition: ['02', '03', '04'],
    },
  ],
};

/**
 * TODO: マスタ化したら削除
 */
export const negotiationResultTypeMapping: {
  [key: string]: Array<SearchBranch>;
} = {
  '00': [],
  '01': [
    {
      branchConditionName: 'negotiationProgressType',
      specifiedCondition: ['02'],
    },
  ],
  '02': [
    {
      branchConditionName: 'negotiationProgressType',
      specifiedCondition: ['03'],
    },
  ],
  '03': [
    {
      branchConditionName: 'negotiationProgressType',
      specifiedCondition: ['05'],
    },
  ],
  '04': [],
  '05': [
    {
      branchConditionName: 'negotiationProgressType',
      specifiedCondition: ['04'],
    },
  ],
  '06': [],
  '07': [
    {
      branchConditionName: 'negotiationProgressType',
      specifiedCondition: ['01'],
    },
  ],
  '99': [],
};

export const commodityCategoryType: string[][] = [
  ['01', 'HS(スマホ)'],
  ['02', 'HS(スマホ以外)'],
  ['03', 'タブレット'],
  ['04', 'その他（モバイル）'],
  ['05', 'SB光'],
  ['06', 'SBAir'],
  ['07', 'おうちでんき'],
  ['08', 'おうちのでんわ'],
  ['09', 'SIM単体'],
  ['10', 'あんしんデータボックス'],
  ['11', 'バスケットLIVE'],
  ['12', '店頭スマホサポート（他社）'],
];

export const CONVERT_DETAIL_DISPLAY_TYPE: {
  [key: string]: { name: string; convertList: string[][] };
} = {
  COMMODITY_CATEGORY_CONTRACT_TYPE: {
    name: 'commodityCategoryContractType',
    convertList: commodityCategoryContractTypeList,
  },
  COMMODITY_CATEGORY_TYPE: {
    name: 'commodityCategoryType',
    convertList: commodityCategoryType,
  },
};

export const contractAccuracyViewColumns = [
  ['01', 'A'],
  ['02', 'B'],
  ['03', 'C'],
  ['04', 'D'],
  ['05', 'E'],
  ['00', '未入力'],
  ['total', '合計'],
];

export const periodViewColumns = [
  ['today', '当日'],
  ['tomorrow', '翌日'],
  ['week', '当週'],
  ['month', '当月'],
  ['overdue', '期日超過'],
  ['nextmonth', '翌月'],
  ['unset', '未入力'],
];

export const actionViewColumns = [
  ['01', '来店予定'],
  ['02', '架電予定'],
  ['03', '入電待ち'],
  ['00', '未入力'],
  ['total', '合計'],
];

export const negotiationResultViewColumns = [
  ['01', '成約済み'],
  ['05', '利用中'],
  ['02', '契約不成立'],
  ['total', '合計'],
];
// GAイベント用定数
export const GA_EVENT_CATEGORY = {
  CREW: '[CREW]_クルー',
  AGENCY: '[AGENCY]_代理店',
  EMPLOYEE: '[EMPLOYEE]_営業',
};

const DASHBOARD_LABEL = {
  NAME: '絞り込み表示',
};

// ID採番はPCMNG000をインクリメントさせる方針とする
// 画面に応じたプレフィックス(PCMNGの部分)の使い分けはしない
// 数値の最大値はドキュメントを確認する
export const SCREEN = {
  DASHBOARD: {
    ID: 'PCMDB001',
    NAME: 'ダッシュボード',
    URL: '/',
  },
  UNDER_NEGOTIATION: {
    ID: 'PCMDB002',
    NAME: 'ステータス別：商談中',
    URL: '/UnderNegotiation',
  },
  PENDING_NEGOTIATION: {
    ID: 'PCMDB003',
    NAME: 'ステータス別：長期保留',
    URL: '/PendingNegotiation',
  },
  DONE_NEGOTIATION: {
    ID: 'PCMDB004',
    NAME: 'ステータス別：商談終了',
    URL: '/DoneNegotiation',
  },
  NEGOTIATION_SEARCH_RESULT: {
    ID: 'PCMSL001',
    NAME: '商談一覧',
    URL: '/search',
  },
  CUSTOMER_INFO_LIST: {
    ID: 'PCMSL002',
    NAME: '顧客一覧',
    URL: '/customerInfoList',
  },
  NEGOTIATION_DETAIL: {
    ID: 'PCMNG002',
    NAME: '商談情報',
    URL: '/negotiation/detail',
  },
  SUMMARY_PREVIEW: {
    ID: 'PCMNG022',
    NAME: 'サマリー',
    URL: '/summary/preview',
  },
  NEGOTIATION_CREATE: {
    ID: 'PCMNG004',
    NAME: '商談追加',
    URL: '/negotiation/edit',
  },
  PRODUCT_CREATE: {
    ID: 'PCMNG005',
    NAME: '商品追加',
    URL: '/product/edit',
  },
  ACTION_CREATE: {
    ID: 'PCMNG006',
    NAME: 'アクション追加',
    URL: '/action/edit',
  },
  CUSTOMER_DETAIL: {
    ID: 'PCMNG001',
    NAME: 'お客さま情報',
    URL: '/customer/detail',
  },
  MAIL_TOP: {
    ID: 'PCMMS001',
    NAME: 'メール',
    URL: '/mail/top',
  },
  MAIL_TEMPLATE_CONFIRM: {
    ID: 'PCMMS002',
    NAME: 'メールテンプレート内容確認',
    URL: '/mail/template/confirm',
  },
  MAIL_TEMPLATE_APPLY: {
    ID: 'PCMMS003',
    NAME: 'メールテンプレート申請',
    URL: '/mail/template/apply',
  },
  MAIL_TEMPLATE_LIST: {
    ID: 'PCMMS004',
    NAME: 'テンプレート管理',
    URL: '/mail/template/list',
  },
  MAIL_TEMPLATE_DETAIL: {
    ID: 'PCMMS005',
    NAME: 'メールテンプレート詳細',
    URL: '/mail/template/detail',
  },
  MAIL_CREATE: {
    ID: 'PCMMS006',
    NAME: 'メール作成',
    URL: '/mail/create',
  },
  MAIL_ADDRESS_SELECT: {
    ID: 'PCMMS007',
    NAME: '宛先選択',
    URL: '/mail/address/select',
  },
  MAIL_SEND: {
    ID: 'PCMMS008',
    NAME: 'メール送信内容確認',
    URL: '/mail/send',
  },
  MAIL_DETAIL: {
    ID: 'PCMMS009',
    NAME: 'メール詳細',
    URL: '/mail/detail',
  },
  MAIL_STOP: {
    ID: 'PCMMS010',
    NAME: 'メール配信停止',
    URL: '/mail/stop',
  },
  MAIL_STOP_DONE: {
    ID: 'PCMMS011',
    NAME: 'メール配信停止完了',
    URL: '/mail/stop/done',
  },
  MAIL_OPTIN: {
    ID: 'PCMMS027',
    NAME: 'メール受信の許諾画面',
    URL: '/mail/optin',
  },
  MAIL_OPTIN_DONE: {
    ID: 'PCMMS028',
    NAME: 'メール受信の許諾完了画面',
    URL: '/mail/optin/done',
  },
  MAIL_OPTIN_ERROR: {
    ID: 'PCMMS029',
    NAME: 'メール受信の許諾エラー画面',
    URL: '/mail/optin/error',
  },
  CUSTOMER_CREATE: {
    ID: 'PCMNG003',
    NAME: '顧客登録',
    URL: '/customer/edit',
  },
  MAIL_SYS_MAINTE: {
    ID: 'PCMMS013',
    NAME: 'メール配信停止システムメンテナンス',
    URL: '/mail/sysmeinte',
  },
  VISIT: {
    ID: 'PCMVR001',
    NAME: '来店予約',
    URL: '/visit',
    TAB_LIST: [
      {
        title: 'サマリー',
        type: 'summary',
        url: '/visit/summary',
      },
      {
        title: '予約一覧',
        type: 'list',
        url: '/visit/list',
      },
    ],
  },
  MY_SET: {
    ID: 'PCMNG040',
    NAME: '設定',
    URL: '/my-set',
  },
  PROXY_LOGIN: {
    ID: 'PCMCM008',
    NAME: '代理ログイン',
    URL: '/proxylogin',
  },
  LINKED_DATA_RESULT: {
    ID: 'PCMP00870',
    NAME: '登録連携情報一覧',
    URL: '/linkedDataResult',
  },
  CORPORATE_CUSTOMER_LIST: {
    ID: 'PCMP00880',
    NAME: '法人連携一覧',
    URL: '/corporateCustomerList',
  },
};

export interface ScrollInfo {
  size: number;
  from: number;
}
export interface sortButtonStatus {
  lastUpdateDate: string;
  createDate: string;
  contractAccuracyType: string;
  actionDate: string;
}

export interface SalesmanInfo {
  salesmanCd: string;
  salesmanName: string;
}

/**
 * 並び順の定義
 */
export const SORT_TYPES_BASE = {
  /**
   * 昇順
   */
  ASC: 'asc',
  /**
   * 降順
   */
  DESC: 'desc',
} as const;
/**
 * 並び順のタイプ
 * ※データを並び替える場合、以下の2種類以外はあり得ないので、このtypeを使用して型セーフで実装してほしい
 */
export type SortType = typeof SORT_TYPES_BASE[keyof typeof SORT_TYPES_BASE];

export const SORT_TYPE: { [key: string]: string } = {
  // 更新日が新しい順
  LAST_UPDATE_DATE_DESC: '001',
  // 契約確率が高い順
  CONTRACT_ACCURACY_TYPE_ASC: '002',
  // アクション予定日が近い順
  ACTION_DATE_DESC: '003',
  // 更新日が古い順
  LAST_UPDATE_DATE_ASC: '101',
  // 契約確率が低い順
  CONTRACT_ACCURACY_TYPE_DESC: '102',
  // アクション予定日が遠い順
  ACTION_DATE_ASC: '103',
  // 作成日が新しい順
  CREATE_DATE_DESC: '004',
  // 作成日が古い順
  CREATE_DATE_ASC: '104',
  // 他社携帯利用中が多い順
  FAMILY_STRUCTOURE_OTHER_COUNT_DESC: '005',
  // 他社携帯利用中が少ない順
  FAMILY_STRUCTOURE_OTHER_COUNT_ASC: '105',
};

/**
 * ソート対象カラム定義
 */
export const SORT_TARGET_COLUMNS = {
  /**
   * 更新日時
   */
  UPDATE_DATETIME: 'updateDate',
  /**
   * 作成日時
   */
  CREATE_DATETIME: 'createDate',
  /**
   * 契約確率
   */
  CONTACT_PROBABILITY: 'contractAccuracyType',
  /**
   * アクション予定日
   */
  ACTION_DATE: 'actionDate',
  /**
   * 他社携帯利用人数
   */
  OTHER_USE_COUNT: 'familyStructureOtherCount',
} as const;

export type SortTargetColumn = typeof SORT_TARGET_COLUMNS[keyof typeof SORT_TARGET_COLUMNS];

/**
 * 顧客一覧のドロップダウンリスト用
 */
export const SORT_TYPE_COMBI: { [key: string]: { col: SortTargetColumn; order: SortType } } = {
  // 更新日が新しい順
  LAST_UPDATE_DATE_DESC: {
    col: SORT_TARGET_COLUMNS.UPDATE_DATETIME,
    order: SORT_TYPES_BASE.DESC,
  },
  // 契約確率が高い順
  CONTRACT_ACCURACY_TYPE_ASC: {
    col: SORT_TARGET_COLUMNS.CONTACT_PROBABILITY,
    order: SORT_TYPES_BASE.ASC,
  },
  // アクション予定日が近い順
  ACTION_DATE_DESC: {
    col: SORT_TARGET_COLUMNS.ACTION_DATE,
    order: SORT_TYPES_BASE.DESC,
  },
  // 更新日が古い順
  LAST_UPDATE_DATE_ASC: {
    col: SORT_TARGET_COLUMNS.UPDATE_DATETIME,
    order: SORT_TYPES_BASE.ASC,
  },
  // 契約確率が低い順
  CONTRACT_ACCURACY_TYPE_DESC: {
    col: SORT_TARGET_COLUMNS.CONTACT_PROBABILITY,
    order: SORT_TYPES_BASE.DESC,
  },
  // アクション予定日が遠い順
  ACTION_DATE_ASC: {
    col: SORT_TARGET_COLUMNS.ACTION_DATE,
    order: SORT_TYPES_BASE.ASC,
  },
  // 作成日が新しい順
  CREATE_DATE_DESC: {
    col: SORT_TARGET_COLUMNS.CREATE_DATETIME,
    order: SORT_TYPES_BASE.DESC,
  },
  // 作成日が古い順
  CREATE_DATE_ASC: {
    col: SORT_TARGET_COLUMNS.CREATE_DATETIME,
    order: SORT_TYPES_BASE.ASC,
  },
  // 他社携帯利用中が多い順
  FAMILY_STRUCTOURE_OTHER_COUNT_DESC: {
    col: SORT_TARGET_COLUMNS.OTHER_USE_COUNT,
    order: SORT_TYPES_BASE.DESC,
  },
  // 他社携帯利用中が少ない順
  FAMILY_STRUCTOURE_OTHER_COUNT_ASC: {
    col: SORT_TARGET_COLUMNS.OTHER_USE_COUNT,
    order: SORT_TYPES_BASE.ASC,
  },
};

export const SORT_TYPE_NAME: { [key: string]: string } = {
  // 更新日が新しい順
  LAST_UPDATE_DATE_DESC: '更新日が新しい順',
  // 契約確率が高い順
  CONTRACT_ACCURACY_TYPE_ASC: '契約確率が高い順',
  // アクション予定日が近い順
  ACTION_DATE_DESC: 'アクション予定日が近い順',
  // 更新日が古い順
  LAST_UPDATE_DATE_ASC: '更新日が古い順',
  // 契約確率が低い順
  CONTRACT_ACCURACY_TYPE_DESC: '契約確率が低い順',
  // アクション予定日が遠い順
  ACTION_DATE_ASC: 'アクション予定日が遠い順',
  // 作成日が新しい順
  CREATE_DATE_DESC: '作成日が新しい順',
  // 作成日が古い順
  CREATE_DATE_ASC: '作成日が古い順',
  // 他社携帯利用中が多い順
  FAMILY_STRUCTOURE_OTHER_COUNT_DESC: '他社携帯利用中が多い順',
  // 他社携帯利用中が少ない順
  FAMILY_STRUCTOURE_OTHER_COUNT_ASC: '他社携帯利用中が少ない順',
};

/**
 * ソート条件の表示順序
 */
export const SORT_CONDITIONS_ORDER = [
  'LAST_UPDATE_DATE_DESC',
  'LAST_UPDATE_DATE_ASC',
  'CREATE_DATE_DESC',
  'CREATE_DATE_ASC',
  'CONTRACT_ACCURACY_TYPE_ASC',
  'CONTRACT_ACCURACY_TYPE_DESC',
  'ACTION_DATE_DESC',
  'ACTION_DATE_ASC',
  'FAMILY_STRUCTOURE_OTHER_COUNT_DESC',
  'FAMILY_STRUCTOURE_OTHER_COUNT_ASC',
];

export const DEFAULT_PAGE_VIEW = {
  RECORD_ROWS: 10,
  CURRENT_PAGE: 1,
  API_UPDATE_INDEX: 11,
};

export const DEFAULT_SCROLL_INFO = {
  SIZE: 200,
  FROM: 0,
};

export interface SimpleDictionary {
  [key: string]: string;
}

// 画面表示上の日本語とキーの対応定義
export const DISPLAY_NAMES: SimpleDictionary = {
  keyword: 'フリーワード',

  dateCategory: '期間指定',
  createDate: '初回登録日',
  latestUpdateDate: '最終更新日',
  actionDate: 'アクション予定日',
  callDate: '架電予定日',
  comeDate: '来店予定日',
  commodityCategoryContractType: '商材カテゴリ契約区分',
  commodityCategoryType: '商材カテゴリ区分',

  period: '対象期間',

  smartphone: 'HSスマホ',
  telephone: 'HSスマホ以外',
  accessary: '副商材',

  today: '当日',
  tomorrow: '翌日',
  week: '当週',
  month: '当月',
  nextmonth: '翌月',
  overdue: '期日超過',
  unset: '未入力',
  '3rdMonth': '翌々月',
  '4thMonth': '翌々々月',
  '5thMonth': '翌々々々月',

  smartphoneNew: 'HSスマホ 新規',
  smartphoneTransfer: 'HSスマホ 番号移行',
  smartphoneChange: 'HSスマホ 機種変更',
  smartphoneMnp: 'HSスマホ MNP',
  smartphoneContrChg: 'HSスマホ 契約変更',
  garakeiNew: 'HSスマホ以外 新規',
  garakeiTransfer: 'HSスマホ以外 番号移行',
  garakeiChange: 'HSスマホ以外 機種変更',
  garakeiMnp: 'HSスマホ以外 MNP',
  garakeiContrChg: 'HSスマホ以外 契約変更',
  tabletNew: 'タブレット 新規',
  tabletTransfer: 'タブレット 番号移行',
  tabletChange: 'タブレット 機種変更',
  tabletMnp: 'タブレット MNP',
  tabletContrChg: 'タブレット 契約変更',
  otherNew: 'その他（モバイル） 新規',
  otherTransfer: 'その他（モバイル） 番号移行',
  otherChange: 'その他（モバイル） 機種変更',
  otherMnp: 'その他（モバイル） MNP',
  otherContrChg: 'その他（モバイル） 契約変更',
  hikariNew: 'ソフトバンク光 新規',
  hikariDiverted: 'ソフトバンク光 転用',
  hikariChange: 'ソフトバンク光 事業者変更',
  hikariSrvChgAurora: 'ソフトバンク光 サービス変更（SB光＋）',
  hikariSrvChgAir: 'ソフトバンク光 サービス変更（SB Air）',
  hikariSrvChgBbisp: 'ソフトバンク光 サービス変更（BBISP）',
  airNew: 'ソフトバンクAir 新規',
  airChange: 'ソフトバンクAir 機種変更',
  airSrvChgHikari: 'ソフトバンクAir サービス変更（SB 光）',
  airSrvChgAurora: 'ソフトバンクAir サービス変更（SB光＋）',
  denwaNew: 'おうちのでんわ 新規',
  denkiNew: 'おうちでんき 新規',
  simNew: 'SIM単体 新規',
  simTransfer: 'SIM単体 番号移行',
  simChange: 'SIM単体 機種変更',
  simMnp: 'SIM単体 MNP',
  simContrChg: 'SIM単体 契約変更',
  dataBoxNew: 'あんしんデータボックス 新規',
  basketLiveNew: 'バスケットLIVE 新規',
  smartphoneSetSupportNew: '店頭スマホサポート（他社） 新規（定額加入／サポート利用）',

  statusType: 'ステータス',
  negotiationStatus: '商談ステータス',
  done: '商談終了',
  pending: '長期保留',
  doing: '商談中',

  holdPeriodType: '保留期間',
  actionType: '次アクション',
  periodType: '対応期間',
  contractAccuracyType: '契約確率',
  negotiationResultType: '商談結果',

  // 検索で使用する項目を追加
  // 顧客
  customerFullName: 'お客さま氏名',
  customerKanaFullName: 'お客さま指名ふりがな',
  customerId: 'お客さま番号',
  familyStructureType: '家族構成',
  contactMsn: '連絡先',

  // 商談
  closingSalesmanCd: '担当者クルーコード',
  closingSalesmanName: '担当者',
  //アクションは上で定義済み
  tempCd1: '臨時コード①',
  tempCd: '臨時コード（その他）',
  //商材カテゴリは上で定義済み
  registerReasonType: '対応内容',
  projectCd: '案件名',
  //商談ステータスは上で定義済み
  //契約確率は上で定義済み

  // モバイル
  wrkType: '受付内容',
  mobileConsiderNumType: '検討台数',

  // SB光
  wrkTypeSbb: '受付内容',

  detail_commodityType: '詳細条件（仮）',
};

export const DISPLAY_NAMES_STATUS_TYPE: SimpleDictionary = {
  '01': '商談中',
  '02': '商談終了',
  '03': '長期保留',
};

// 詳細条件設定に表示する searchCondition の項目
export const DETAIL_SEARCH_CONDITION_KEYS = [
  'statusType',
  'commodityCategoryContractType',
  'detail_commodityType',
  'period',
  'action',
  'probability',
  'negotiationResult',
  'negotiationStatus',
  'holdPeriodType',
  'actionType',
  'periodType',
  'contractAccuracyType',
  'negotiationResultType',
  'holdPeriodType',
  'commodityCategoryType',
];

// パーミッションモーダルの種別
export const PERMISSION_MODAL_TYPE = {
  // 情報保持許諾
  INFORMATION_RETENTION: 'A',
  // 情報更新許諾
  INFORMATION_EDIT: 'B',
} as const;
export type PermissionModalType = typeof PERMISSION_MODAL_TYPE[keyof typeof PERMISSION_MODAL_TYPE];

// 許諾種類
export const PERMISSION_TYPE = {
  // 対面
  FACE_TO_FACE: '01',
  // 非対面
  NON_FACE_TO_FACE: '02',
  // 情報修正
  EDIT_INFO: '03',
  // その他
  OTHER: '04',
} as const;
export type PermissionType = typeof PERMISSION_TYPE[keyof typeof PERMISSION_TYPE];

/**
 * 検索条件の文字列を作成する
 *
 * @param conditionName
 * @param specifiedConditions
 */
export function makeSearchConditionDisplayStr(condition: ConditionItem) {
  const conditionName: string = condition.branchConditionName;
  const conditionTitle: string = DISPLAY_NAMES[conditionName] ? DISPLAY_NAMES[conditionName] : conditionName;

  switch (conditionName) {
    case 'createDate':
    case 'latestUpdateDate':
    case 'actionDate':
    case 'callDate':
    case 'comeDate':
      return `${conditionTitle}:${condition.specifiedCondition.join('-')}`;
    default:
      return `${conditionTitle}:${condition.specifiedCondition
        .map((item) => getSpecifiedConditionName(conditionName, item ? item : ''))
        .join(',')}`;
  }
}

export function getSpecifiedConditionName(conditionName: string, specifiedCondition: string): string {
  let dic: SimpleDictionary = {};
  switch (conditionName) {
    case 'contractAccuracyType':
      dic = viewColumnsToDic(contractAccuracyViewColumns);
      break;
    case 'periodType':
      dic = viewColumnsToDic(periodViewColumns);
      break;
    case 'actionType':
      dic = viewColumnsToDic(actionViewColumns);
      break;
    case 'negotiationResultType':
      dic = viewColumnsToDic(negotiationResultViewColumns);
      break;
    case 'holdPeriodType':
      dic = viewColumnsToDic(pendingViewColumns);
      break;
    case 'statusType':
      dic = DISPLAY_NAMES_STATUS_TYPE;
      break;
    case CONVERT_DETAIL_DISPLAY_TYPE.COMMODITY_CATEGORY_CONTRACT_TYPE.name:
      dic = viewColumnsToDic(CONVERT_DETAIL_DISPLAY_TYPE.COMMODITY_CATEGORY_CONTRACT_TYPE.convertList);
      break;
    case CONVERT_DETAIL_DISPLAY_TYPE.COMMODITY_CATEGORY_TYPE.name:
      dic = viewColumnsToDic(CONVERT_DETAIL_DISPLAY_TYPE.COMMODITY_CATEGORY_TYPE.convertList);
      break;
    default:
      dic = DISPLAY_NAMES;
      break;
  }
  return dic[specifiedCondition] ? dic[specifiedCondition] : specifiedCondition;
}

function viewColumnsToDic(columns: string[][]): SimpleDictionary {
  const dic: SimpleDictionary = {};
  columns.forEach((item) => {
    dic[item[0]] = item[1];
  });
  return dic;
}

/**
 * 2つの検索条件が一致しているかどうかを判定する.
 *
 * @param a 検索条件1
 * @param b 検索条件2
 */
export function isSameSearchCondition(a: SearchConditionState, b: SearchConditionState): boolean {
  if (a === b) {
    return true;
  }
  if (Object.keys(a).length != Object.keys(b).length) {
    return false;
  }

  for (let i = 0; i < a.length; i++) {
    const iIndex = getFindIndex(b, a[i].searchConditionName);

    // aにある検索条件がbに存在しない場合、falseを返却
    if (iIndex === -1) {
      return false;
    } else {
      if (
        a[i].searchConditionGroupId !== b[iIndex].searchConditionGroupId ||
        compareSpecifiedCondition(a[i].specifiedCondition, b[iIndex].specifiedCondition)
      ) {
        return false;
      }
    }
  }

  return true;
}

/**
 *
 * @param specifiedConditionA
 * @param specifiedConditionB
 *
 * @returns
 * 指定条件が異なる場合、Trueを返却する。
 * 指定条件が同じ場合、Falseを返却する。
 */
function compareSpecifiedCondition(specifiedConditionA: (string | null)[], specifiedConditionB: (string | null)[]): boolean {
  // Step1. AとB配列の長さが異なるとTrueを返却する
  if (specifiedConditionA.length !== specifiedConditionB.length) {
    return true;
  }

  for (let i = 0; i < specifiedConditionA.length; i++) {
    if (specifiedConditionA[i] !== specifiedConditionB[i]) {
      return true;
    }
  }

  return false;
}

export const AUTH_ROLE: {
  [key: string]: {
    name: string;
    isBillcstmDisplay: boolean;
    isMngcstmDisplay: boolean;
  };
} = {
  '0600': {
    name: '広域代理店閲覧者',
    isBillcstmDisplay: true,
    isMngcstmDisplay: true,
  },
  '0601': {
    name: '広域代理店責任者',
    isBillcstmDisplay: true,
    isMngcstmDisplay: true,
  },
  '0610': {
    name: '一次代理店閲覧者',
    isBillcstmDisplay: false,
    isMngcstmDisplay: true,
  },
  '0611': {
    name: '一次代理店責任者',
    isBillcstmDisplay: false,
    isMngcstmDisplay: true,
  },
  '0620': {
    name: '法人閲覧者',
    isBillcstmDisplay: false,
    isMngcstmDisplay: true,
  },
  '0621': {
    name: '法人責任者',
    isBillcstmDisplay: false,
    isMngcstmDisplay: true,
  },
  '0630': {
    name: '運営店閲覧者',
    isBillcstmDisplay: false,
    isMngcstmDisplay: false,
  },
  '0631': {
    name: '運営店責任者',
    isBillcstmDisplay: false,
    isMngcstmDisplay: false,
  },
};

export const CATEGORY_VALIDATION: {
  [key: string]: {
    validation: RegExp;
    editMessage: string;
  };
} = {
  number: { validation: /^[0-9]*$/, editMessage: '数字のみ入力できます。' },
  tel: { validation: /^([0-9]{0,11})$/, editMessage: '数字のみ入力できます。' },
  halfSize: {
    validation: /^([a-zA-Z0-9])*$/,
    editMessage: '半角英数字のみ入力できます。',
  },
};

export const SESSION_DISCONNECT = 'SessionDisconnect';

export const CUSTOMER_NAME_INFO_TYPE = {
  KANJI: '0',
  ENGLISH: '1',
  CORPORATION: '2',
};

export const CUSTOMER_NAME_INFO_LIST = [
  {
    type: CUSTOMER_NAME_INFO_TYPE.KANJI,
    name: '漢字',
  },
  {
    type: CUSTOMER_NAME_INFO_TYPE.ENGLISH,
    name: '英字',
  },
  {
    type: CUSTOMER_NAME_INFO_TYPE.CORPORATION,
    name: '法人',
  },
];

export const ACTION_TAG: {
  [key: string]: {
    name: string;
    icon: string;
  };
} = {
  '01': {
    name: '来店',
    icon: 'store',
  },
  '02': {
    name: '架電',
    icon: 'phone_forwarded',
  },
  '03': {
    name: '受電待ち',
    icon: 'phone_missed',
  },
};

export const ACTION_TAG_CLASSNAMES: { [key: string]: string } = {
  // 来店
  '01': 'scheduledToVisit',
  // 架電
  '02': 'callSchedule',
  // 受電待ち
  '03': 'waitingForIncomingCall',
};

export const UPDATE_TYPE: {
  [key: string]: {
    name: string;
  };
} = {
  '01': {
    name: '登録',
  },
  '02': {
    name: '更新',
  },
  '03': {
    name: '削除',
  },
};

export const UPDATE_SYSTEM: {
  [key: string]: {
    name: string;
  };
} = {
  M00002: {
    name: 'GINIE',
  },
  M00083: {
    name: 'BB-GINIE',
  },
  M00807: {
    name: '料金シミュレーター',
  },
  M00083_AREA: {
    name: 'エリア検索',
  },
  M00843: {
    name: 'ヒアナビ',
  },
};

export const UPDATE_USER: {
  [key: string]: {
    name: string;
  };
} = {
  AP_113: {
    name: 'モバトス（ショップ）',
  },
  BT_C036: {
    name: 'モバトス（ショップ）',
  },
  Customer: {
    name: 'お客さま',
  },
};

export const DAY_TYPE: {
  [key: string]: {
    name: string;
  };
} = {
  '0': {
    name: '日付予定なし',
  },
  '1': {
    name: '平日',
  },
  '2': {
    name: '休日',
  },
  '3': {
    name: '日付指定',
  },
};

export const ACTION_TIME_TYPE: {
  [key: string]: {
    name: string;
  };
} = {
  '01': {
    name: '時間指定',
  },
  '02': {
    name: 'AM',
  },
  '03': {
    name: 'PM',
  },
};

export enum ACTION_TYPE {
  /** 未入力 */
  NOT_ENTERED = '00',
  /** 来店予定 */
  SCHEDULED_TO_VISIT = '01',
  /** 架電予定 */
  CALL_SCHEDULE = '02',
  /** 入電待ち */
  WAITING_FOR_INCOMING_CALL = '03',
}

export enum NEGOTIATION_STATUS_TYPE {
  /** 商談中 */
  IN_NEGOTIATION = '01',
  /** 商談終了 */
  NEGOTIATION_END = '02',
  /** その他 */
  OTHER = '99',
}

export enum NEGOTIATION_RESULT_TYPE {
  /** 未入力 */
  NOT_ENTERED = '00',
  /** 契約成立 */
  SATISFIED = '01',
  /** 契約不成立 */
  UNSATISFIED = '02',
  /** 提案前 */
  BEFORE_PROPOSAL = '03',
  /** 仮登録中 */
  IN_TEMPORARY_REGISTRATION = '04',
  /** 利用中 */
  USING = '05',
  /** メール送信済 */
  EMAIL_SENT = '06',
  /** 商談中 */
  IN_NEGOTIATION = '07',
  /** その他 */
  OTHER = '99',
}

export enum CONTRACT_ACCURACY_TYPE {
  /** 未入力 */
  NOT_ENTERED = '00',
  /** A */
  A = '01',
  /** B */
  B = '02',
  /** C */
  C = '03',
  /** D */
  D = '04',
  /** E */
  E = '05',
  /** その他 */
  OTHER = '99',
}

export enum COMMODITY_CATEGORY_TYPE {
  /** スマホ */
  SMARTPHONE = '01',
  /** スマホ以外 */
  HS_EXCEPT_SMARTPHONES = '02',
  /** タブレット */
  TABLET = '03',
  /** その他（モバイル） */
  MOBILE_OTHER = '04',
  /** SB光 */
  SOFTBANK_HIKARI = '05',
  /** SBAir */
  SOFTBANK_AIR = '06',
  /** おうちでんき */
  ELECTRICITY = '07',
  /** おうちのでんわ */
  HOME_PHONE = '08',
  /** SIM単体*/
  SIM_ONLY = '09',
  /** あんしんデータボックス */
  DATA_BOX = '10',
  /** バスケットLIVE */
  BASKET_LIVE = '11',
  /** 店頭スマホサポート（他社） */
  SMARTPHONE_SET_SUPPORT = '12',
  /** SoftBank 光＋ */
  SOFTBANK_HIKARI_PLUS = '13',
  /** その他 */
  ALL_OTHER = '99',
  /** 未選択 */
  NOT_ENTERED = '00',
}

// キャリアフリー項目用
export const CARRIER_COMMODITY_CATEGORY = {
  pcmCd: '100',
  pcmCdNm: 'キャリアフリー',
};

export const COMMODITY_CATEGORY_TYPE_DIC: {
  [key: string]: {
    commodityCategoryType: COMMODITY_CATEGORY_TYPE;
  };
} = {
  '01': {
    commodityCategoryType: COMMODITY_CATEGORY_TYPE.SMARTPHONE,
  },
  '02': {
    commodityCategoryType: COMMODITY_CATEGORY_TYPE.HS_EXCEPT_SMARTPHONES,
  },
  '03': {
    commodityCategoryType: COMMODITY_CATEGORY_TYPE.TABLET,
  },
  '04': {
    commodityCategoryType: COMMODITY_CATEGORY_TYPE.MOBILE_OTHER,
  },
  '05': {
    commodityCategoryType: COMMODITY_CATEGORY_TYPE.SOFTBANK_HIKARI,
  },
  '06': {
    commodityCategoryType: COMMODITY_CATEGORY_TYPE.SOFTBANK_AIR,
  },
  '07': {
    commodityCategoryType: COMMODITY_CATEGORY_TYPE.ELECTRICITY,
  },
  '08': {
    commodityCategoryType: COMMODITY_CATEGORY_TYPE.HOME_PHONE,
  },
  '09': {
    commodityCategoryType: COMMODITY_CATEGORY_TYPE.SIM_ONLY,
  },
  '10': {
    commodityCategoryType: COMMODITY_CATEGORY_TYPE.DATA_BOX,
  },
  '11': {
    commodityCategoryType: COMMODITY_CATEGORY_TYPE.BASKET_LIVE,
  },
  '12': {
    commodityCategoryType: COMMODITY_CATEGORY_TYPE.SMARTPHONE_SET_SUPPORT,
  },
  '13': {
    commodityCategoryType: COMMODITY_CATEGORY_TYPE.SOFTBANK_HIKARI_PLUS,
  },
  '99': {
    commodityCategoryType: COMMODITY_CATEGORY_TYPE.ALL_OTHER,
  },
};

export const arrayInternetAndLandLine: COMMODITY_CATEGORY_TYPE[] = [
  COMMODITY_CATEGORY_TYPE.SOFTBANK_HIKARI,
  COMMODITY_CATEGORY_TYPE.SOFTBANK_AIR,
  COMMODITY_CATEGORY_TYPE.HOME_PHONE,
];

export const arrayMobile: COMMODITY_CATEGORY_TYPE[] = [
  COMMODITY_CATEGORY_TYPE.SMARTPHONE,
  COMMODITY_CATEGORY_TYPE.HS_EXCEPT_SMARTPHONES,
  COMMODITY_CATEGORY_TYPE.TABLET,
  COMMODITY_CATEGORY_TYPE.MOBILE_OTHER,
  COMMODITY_CATEGORY_TYPE.SIM_ONLY,
];

export const arrayCarrierFree: COMMODITY_CATEGORY_TYPE[] = [
  COMMODITY_CATEGORY_TYPE.DATA_BOX,
  COMMODITY_CATEGORY_TYPE.BASKET_LIVE,
  COMMODITY_CATEGORY_TYPE.SMARTPHONE_SET_SUPPORT,
];

export const COMMODITY_CATEGORY_TAG: {
  [key: string]: {
    name: string;
    icon: string;
    outlined: string;
  };
} = {
  '01': {
    name: 'HS（スマホ）',
    icon: 'phone_iphone',
    outlined: '',
  },
  '02': {
    name: 'HS（スマホ以外）',
    icon: 'phone_iphone',
    outlined: '',
  },
  '03': {
    name: 'タブレット',
    icon: 'phone_iphone',
    outlined: '',
  },
  '04': {
    name: 'その他（モバイル）',
    icon: 'phone_iphone',
    outlined: '',
  },
  '05': {
    name: 'SB光',
    icon: 'language',
    outlined: '',
  },
  '06': {
    name: 'SBAir',
    icon: 'language',
    outlined: '',
  },
  '07': {
    name: 'おうちでんき',
    icon: 'lightbulb_outline',
    outlined: '',
  },
  '08': {
    name: 'おうちのでんわ',
    icon: 'language',
    outlined: '',
  },
  '09': {
    name: 'SIM単体',
    icon: 'phone_iphone',
    outlined: '',
  },
  '10': {
    name: 'あんしんデータボックス',
    icon: 'no_sim',
    outlined: 'material-icons-outlined',
  },
  '11': {
    name: 'バスケットLIVE',
    icon: 'no_sim',
    outlined: 'material-icons-outlined',
  },
  '12': {
    name: '店頭スマホサポート（他社）',
    icon: 'no_sim',
    outlined: 'material-icons-outlined',
  },
  '13': {
    name: 'SoftBank 光＋',
    icon: 'language',
    outlined: '',
  },
  '99': {
    name: 'その他',
    icon: 'devices_other',
    outlined: '',
  },
};

/** 商材ブランド */
export const COMMODITY_BRAND = {
  /** 商材ブランド:SB */
  SB: '1',
  /** 商材ブランド:YM */
  YM: '4',
} as const;
export type CommodityBrand = typeof COMMODITY_BRAND[keyof typeof COMMODITY_BRAND];

export enum REGISTERED_FROM_TYPE {
  /** 新見込 */
  NEW_POTENTIAL = '0',
  /** 旧見込 */
  OLD_POTENTIAL = '1',
  /** BSW */
  BSW = '2',
}

export enum FILE_TYPE {
  /** ご案内書類 */
  INFORMATION_DOCUMENT = '01',
  /** 見積書PDF */
  CNCG_ODR_PDF = '02',
}

/* 見積書連携ステータス */
export enum CNCG_STATUS {
  /** 未ステータス（商談添付画像の場合はESB連携しないため、こちらで固定） */
  NO_STATUS = '0',
  /** ESB連携待ち（見積書PDFの場合はESB連携待ちなのでこちら） */
  NOT_LINKED_TO_ESB = '1',
  /** 2:ESB連携済（見積書PDFの場合） */
  LINKED_TO_ESB = '2',
}

export enum FAMILY_STRUCTURE_INFO_TYPE {
  /** 利用中キャリア */
  USING_CARRIER = '01',
  /** 割引 */
  DISCOUNT = '02',
}

export enum FAMILY_STRUCTURE_INFO_ITEM {
  /** 他社携帯利用中 */
  OTHER_USE = '0101',
  /** SB携帯利用中 */
  SB_USE = '0102',
  /** YM携帯利用中 */
  YM_USE = '0103',
  /** LINEMO携帯利用中 */
  LINEMO_USE = '0104',
  /** おうち割申込済 */
  OTOKU_USE = '0201',
}

export enum DESTINATION_TYPE {
  /** メールを送信しない */
  NOT_SEND = '000',
  /** SB/YM電話番号あてにメールを送信 */
  SEND_TO_CALL = '001',
  /** メールアドレスあてにメールを送信 */
  SEND_TO_MAIL = '002',
}

export enum SEND_TO_CALL_TYPE {
  /** 日中連絡先 */
  DAYTIME_CONTACT = '001',
  /** 緊急連絡先 */
  EMERGENCY_CONTACT = '002',
}

export enum DESTINATION_TYPE_FOR_RESERVE {
  /** 送信なし */
  NOT_SEND = 'N',
  /** MMS送信 */
  SEND_TO_CALL = 'S',
  /** Email送信 */
  SEND_TO_MAIL = 'E',
}

/**
 * @deprecated @common/src/redux/reducers/MasterInfoReducer/DisplayItemId に移行
 */
export enum DISPLAY_ITEM_ID {
  /** 利用中キャリア */
  USING_MOBILE_CARRIER = 'ITEM00008',
  /** 利用中機種 */
  USING_MOBILE_KINDS_NAME = 'ITEM00010',
  /** モバイル更新月 */
  MOBILE_UPD_YEAR_MONTH = 'ITEM00011',
  /** 割賦残債 */
  MOBILE_INSTALL_MONTHLY_PAYMENT = 'ITEM00014',
  /** 割賦残債終了年月 */
  MOBILE_INSTALL_END_YEAR_MONTH = 'ITEM00015',
  /** お住まい */
  HOUSING_TYPE = 'ITEM00026',
  /** エリアチェック結果 */
  INFORMATION_PROVISION_STATUS = 'ITEM00027',
  /** 固定回線の状態 */
  LANDLINE_PHONE_USAGE_STATUS = 'ITEM00028',
  /** 固定回線状態（SB光） */
  FIXED_LINE_STATUS_SB_HIKARI = 'ITEM00228',
  /** 利用中のネット環境 */
  USING_HOME_INTERNET_TYPE = 'ITEM00029',
  /** NTT116確認結果 */
  INTERNETLINE_CONTRACT_HOLDER = 'ITEM00031',
  /** 契約中回線事業者 */
  USING_INTERNETLINE_PROVIDER = 'ITEM00032',
  /** 契約中回線事業者備考欄 */
  USING_INTERNETLINE_PROVIDER_REMARKS = 'ITEM00033',
  /** 契約中プロバイダ */
  USING_LANDLINE_PHONE_PROVIDER = 'ITEM00034',
  /** 契約中プロバイダ備考欄 */
  USING_LANDLINE_PHONE_PROVIDER_REMARKS = 'ITEM00035',
  /** 契約更新月（インターネット・固定電話） */
  USING_INTERNETLINE_UPD_YEAR_MONTH = 'ITEM00036',
  /** 現在の電力事業者 */
  USING_PWR_PROVIDER = 'ITEM00045',
  /** 現在の電力事業者（その他） */
  USING_PWR_PROVIDER_NAME = 'ITEM00046',
  /** 電気料金月 */
  USING_PWR_MONTH = 'ITEM00047',
  /** 電気料金金額 */
  USING_PWR_MONTH_CHARGE = 'ITEM00048',
  /** お住まい（おうちでんき） */
  USING_PWR_HOUSING_TYPE = 'ITEM00049',
  /** 契約形態（モバイル） */
  CONTRACT_TYPE_MOBILE = 'ITEM00054',
  /** 契約形態（SB光） */
  CONTRACT_TYPE_HIKARI = 'ITEM00055',
  /** 契約形態（Air） */
  CONTRACT_TYPE_AIR = 'ITEM00056',
  /** 契約形態（おうちのでんわ） */
  CONTRACT_TYPE_HOME = 'ITEM00060',
  /** 契約形態（おうちでんき） */
  CONTRACT_TYPE_PWR = 'ITEM00061',
  /** 割賦残債（1-24回） */
  USING_MOBILE_INSTALL_MONTHLY_PAYMENT_EARLY = 'ITEM00062',
  /** 特典利用開始日 */
  CAMPAIGN_START_MONTH = 'ITEM00063',
  /** 残債金額 */
  MOBILE_BALANCE = 'ITEM00075',
  /** 加入特典 */
  SUBSCRIPTION_BENEFITS = 'ITEM00076',
  /** 光セット */
  HIKARI_SET = 'ITEM00078',
  /** でんきセット */
  DENKI_SET = 'ITEM00079',
  /** スマートログイン設定 */
  SMART_LOGIN_SETTING = 'ITEM00080',
  /** MSN設定 */
  MSN_SETTING = 'ITEM00081',
  /** 契約確率 */
  CONTRACT_ACCURACY_TYPE = 'ITEM00082',
  /** メールアドレス */
  CUSTOMER_EMAIL_SUFFIX = 'ITEM00084',
  /** 家族構成 */
  FAMILY_INFORMATION = 'ITEM00085',
  /** メール送信先 */
  DESTINATION_TYPE = 'ITEM00086',
  /** 本人確認書類 */
  IDENTITY_VERIFICATION_DOCUMENT_TYPE = 'ITEM00087',
  /** 見込理由 */
  REGISTER_REASON_TYPE = 'ITEM00112',
  /** 見込理由（その他メモ） */
  REGISTER_REASON_TYPE_CONTENTS = 'ITEM00113',
  /** 在留期限年 */
  STAY_DEADLINE = 'ITEM00139',
  /** メール送信回数（当月累計） */
  MAIL_SEND_COUNT_MONTH_TOTAL = 'ITEM00259',
  /** メール送信回数（過去累計） */
  MAIL_SEND_COUNT_ALL_TOTAL = 'ITEM00260',
  /** アクション予定時間FROM */
  ACTION_TIME_FROM_HOUR = 'ITEM00140',
  /** アクション予定時間TO */
  ACTION_TIME_TO_HOUR = 'ITEM00141',
  /** アクション予定時間FROM_架電 */
  ACTION_TIME_FROM_HOUR_K = 'ITEM00223',
  /** アクション予定時間TO_架電 */
  ACTION_TIME_TO_HOUR_K = 'ITEM00224',
  /** アクション完了時間 */
  ACTION_COMPLETE_TIME_HOUR = 'ITEM00142',
  /** アクション予定分FROM */
  ACTION_TIME_FROM_MINUTE = 'ITEM00143',
  /** アクション予定分TO */
  ACTION_TIME_TO_MINUTE = 'ITEM00144',
  /** アクション完了分 */
  ACTION_COMPLETE_TIME_MINUTE = 'ITEM00145',
  /** アクション対応結果 */
  ACTION_STATUS_TYPE = 'ITEM00146',
  /** その他追加書類 */
  OTHER_VERIFICATION_DOCUMENT_TYPE = 'ITEM00148',
  /** 商談ステータス */
  NEGOTIATION_PROGRESS_TYPE = 'ITEM00149',
  /** 契約予定名義 */
  CONTRACTOR_TYPE = 'ITEM00150',
  /** 支払終了月（1-24回） */
  USING_MOBILE_INSTALL_END_YEAR_MONTH_EARLY = 'ITEM00151',
  /** 取り置きメモ */
  KEEP_NOTE = 'ITEM00153',
  /** 業務：契約形態（その他） */
  CONTRACT_TYPE_OTHER = 'ITEM00154',
  /** 業務（その他） */
  OTHER_PRODUCT_BUSINESS_NOTE = 'ITEM00155',
  /** 対応ステータス */
  OTHER_PRODUCT_ACTION_STATUS_TYPE = 'ITEM00156',
  /** 希望プラン（おうちでんき） */
  PWR_HOPE_PRICE_PLAN = 'ITEM00157',
  /** 希望機種有無（未決定メモ） */
  HOPE_KINDS_REMARKS = 'ITEM00158',
  /** 送信先のSB/YM電話番号 */
  SEND_SB_YM_NUMBER = 'ITEM00169',
  /** 一斉送信メール */
  SEND_BULK_MAIL = 'ITEM00170',
  /** Y!Mobileサービスの初期設定 */
  YM_SERVICE_INITIAL_SETTING = 'ITEM00171',
  /** 商材カテゴリ */
  COMMODITY_CATEGORY = 'ITEM00181',
  /** ご利用状況：利用中キャリア（その他） */
  USING_MOBILE_CARRIER_TEXT = 'ITEM00065',
  /** ご利用状況：利用中機種：機種タイプ */
  USING_MOBILE_KIND_TYPE = 'ITEM00009',
  /** ご利用状況：利用中機種：機種名 */
  USING_MOBILE_KIND_NAME = 'ITEM00010',
  /** ご利用状況：請求群 */
  USING_MOBILE_BILLING_GROUP_TYPE = 'ITEM00012',
  /** ご利用状況：毎月のお支払い金額 */
  USING_MOBILE_MONTHLY_PAYMENT = 'ITEM00013',
  /** ご希望の内容：希望機種有無 */
  HOPE_KINDS_FLG = 'ITEM00072',
  /** ご希望の内容：希望機種タイプ */
  HOPE_KINDS_TYPE = 'ITEM00152',
  /** ご希望の内容：希望機種名 */
  HOPE_KINDS_NAME = 'ITEM00002',
  /** ご希望の内容：取り置き */
  KEEP_TYPE = 'ITEM00058',
  /** ご希望の内容：料金プラン */
  PRICE_PLAN = 'ITEM00003',
  /** ご希望の内容：料金プラン(YM) */
  YM_PRICE_PLAN = 'ITEM00159',
  /** ご希望の内容：パケットサービス */
  PACKET_DSCT_SERVICE = 'ITEM00004',
  /** ご希望の内容：店頭スマホサポート */
  SMART_PHONE_SET_SUPPORT = 'ITEM00073',
  /** ご希望の内容：店頭スマホサポート(その他) */
  SMART_PHONE_SET_SUPPORT_TEXT = 'ITEM00074',
  /** その他：特記事項 */
  PRODUCT_NOTICE_AGE_CHECK = 'ITEM00147',
  /** 割賦前半終了回数*/
  USING_MOBILE_INSTALL_EARLY_LAST_COUNT = 'ITEM00232',
}

export enum MESSAGETYPE {
  NORMAL = 'NORMAL',
  OPRATE = 'OPRATE',
}

/**
 * @deprecated @common/src/redux/reducers/MasterInfoReducer/MessageMasterKeys に移行
 */
export enum MESSAGE {
  /** 個別設定 */
  CUSTOM = 'CUSTOM',
  /** 該当する商談で絞り込んでいます */
  I_012 = 'I_012',
  /** 入力内容を保存しました */
  I_013 = 'I_013',
  /** {0}を削除しました */
  I_014 = 'I_014',
  /** メールを送信しました */
  I_015 = 'I_015',
  /** テンプレートを申請しました */
  I_016 = 'I_016',
  /** テンプレートを下書き保存しました */
  I_017 = 'I_017',
  /** 該当するメールで絞り込んでいます */
  I_021 = 'I_021',
  /** アクションが登録上限数（6件）です。不要なアクションを削除してから、新しく追加してください。 */
  I_022 = 'I_022',
}

export const isCloseAction = (actionStatusType?: string): boolean => {
  return actionStatusType ? actionStatusType.substr(2, 1) === '9' : false;
};

/**
 * @deprecated stringDateToFormatString()へ移行する
 * * 代1引数としてよく使われるDate.toLocaleStringをこれから使用禁止とするため(クライアント環境依存関数のため)
 * * ライブラリmomentが非推薦となったためdate-fnsへ移行
 * * https://momentjs.com/docs/#/-project-status/
 */
export const formatDate = (dateStr: string, formatFrom: string, formatTo: string): string => {
  if (!dateStr || !formatFrom || !formatTo) {
    return '';
  }
  return moment(dateStr, formatFrom).format(formatTo);
};

/**
 * @deprecated stringDateToFormatString()へ移行する
 * * 代1引数としてよく使われるDate.toLocaleStringをこれから使用禁止とするため(クライアント環境依存関数のため)
 * * ライブラリmomentが非推薦となったためdate-fnsへ移行
 * * https://momentjs.com/docs/#/-project-status/
 * * eslintでnull!警告
 */
export const formatDateNull = (dateStr: string, formatFrom: string, formatTo: string): string => {
  if (!dateStr || !formatFrom || !formatTo) {
    // TODO lintで警告が出る。⇨使ってる箇所が多く、影響が大きいため後回し
    return null!;
  }
  return moment(dateStr, formatFrom).format(formatTo);
};

/**
 * Date型から指定のフォーマットの文字列へ変換
 * @param date
 * @param toFormat
 * @param locale デフォルトja
 * @returns
 */
export const dateToFormatString = (date: Date | undefined, toFormat: string, locale: Locale = ja): string => {
  if (!date) {
    return '';
  }

  return format(date, toFormat, { locale });
};

/**
 * 文字列型の日付から指定のフォーマットの文字列へ変換
 * @param stringDate
 * @param fromFormat
 * @param toFormat
 * @param locale デフォルトja
 * @returns string
 */
export const stringDateToFormatString = (stringDate: string, fromFormat: string, toFormat: string, locale: Locale = ja): string => {
  const date = parse(stringDate, fromFormat, new Date());
  if (isInvalidDate(date)) {
    return '';
  }

  return dateToFormatString(parse(stringDate, fromFormat, new Date()), toFormat, locale);
};

/**
 * 日付文字列から秒までを取得する関数
 する関数
 * @param dateString - 処理対象の日付文字列
 * @returns - 秒までの日付文字列 （例: "9999-12-31T23:59:59"）
 *            無効な場合は空文字を返却
 */
export const trimDateString = (dateString: string | null | undefined) => {
  return typeof dateString === 'string' && dateString.length >= 19 ? dateString.substring(0, 19) : '';
};

/**
 * Date型のInvalid Date判定
 * @param date
 * @returns
 */
export const isInvalidDate = (date: Date | undefined) => {
  return date ? Number.isNaN(date.getTime()) : true;
};

/**
 * Date型過去日判定
 * @param date1
 * @param date2
 * @returns
 */
export const isPastDay = (date1: Date, date2: Date): boolean => {
  return isBefore(date1.setHours(0, 0, 0, 0), date2.setHours(0, 0, 0, 0));
};

/**
 * Date型同一日付判定
 * @param date1
 * @param date2
 * @returns boolean
 * 日付レベルまで一致を返却します(時刻ズレは考慮しません)
 */
export const isEqualDay = (date1: Date, date2: Date): boolean => {
  return isEqual(date1.setHours(0, 0, 0, 0), date2.setHours(0, 0, 0, 0));
};

/**
 * @deprecated @common/src/redux/reducers/MasterInfoReducer/MasterInfoStateUtils に移行
 */
export const getPcmCdNmFromMasterInfo = (masterInfo: MasterInfoState, displayItemId: DISPLAY_ITEM_ID, pcmCd: string): string => {
  // 画面項目IDを元にPCMコード区分取得
  const pcmCdDivision = masterInfo.displayItemList.find(
    (displayItem) => displayItem.displayItemId === displayItemId,
  )?.setValuePcmCdDivision;
  // PCMコード区分及びPCMコードを元にPCMコード名称取得
  const pcmCdNm = masterInfo.pcmCodeDivisionList
    .find((pcm) => pcm.pcmCdDivision === pcmCdDivision)
    ?.pcmCodeList.find((pcm) => pcm.pcmCd === pcmCd)?.pcmCdNm;
  return pcmCdNm ? pcmCdNm : '';
};

/**
 * @deprecated @common/src/redux/reducers/MasterInfoReducer/MasterInfoStateUtils に移行
 */
export const getMessageFromMasterInfo = (masterInfo: MasterInfoState, messageId: string): string => {
  if (!masterInfo) {
    return '';
  }
  if (!masterInfo.messageList) {
    return '';
  }

  // MessageInfo取得
  const messageInfo = masterInfo.messageList.find((messageItem) => messageItem.messageId === messageId);
  return messageInfo ? messageInfo.message : '';
};

export const getInquiryToday = (jobDateTime?: string): Date => {
  if (jobDateTime) {
    const dStr = jobDateTime.replace(/^([0-9]{4})([0-9]{2})([0-9]{2})([0-9]{2})([0-9]{2})([0-9]{2})$/, '$1/$2/$3 $4:$5:$6');
    const d = new Date(dStr);
    if (!isNaN(d.getTime())) {
      return d;
    }
  }
  return new Date();
};

export enum DATE_YYYYMMDD {
  MIN = '19000101',
  MAX = '99991231',
}

export const getSystemNameBySystemCd = (systemCd: string): string => {
  switch (systemCd) {
    case SYSTEM_CD.GINIE:
      return 'GINIE';

    case SYSTEM_CD.VISIT_RESERVATION:
      return '来店予約';

    case SYSTEM_CD.FEE_SIMULATOR:
      return '料金シミュレータ';

    case SYSTEM_CD.BB_GINIE:
      return 'BB-GINIE';

    case SYSTEM_CD.AREA_SEARCH:
      return 'エリア検索';

    case SYSTEM_CD.HEAR_NAVI:
      return 'ヒアナビ';

    default:
      return systemCd;
  }
};

export function getSpecifiedCondition(searchCondition: SearchConditionState, searchBranchName: string): (string | null)[] {
  const findIndex = getFindIndex(searchCondition, searchBranchName);
  return findIndex !== -1 ? searchCondition[findIndex].specifiedCondition : [];
}

export function getFindIndex(searchCondition: SearchConditionState, searchBranchName: string): number {
  return searchCondition.findIndex((element) => element.searchConditionName === searchBranchName);
}

/**
 * 指定した日付間の経過月数を取得する
 * @param d1 チェックしたい開始日付
 * @param d2 チェックしたい終了日付
 * @returns 月の比較計算結果
 */
export const countDiffMonth = (d1?: Date, d2?: Date): string => {
  if (!d1 || !d2 || !isValid(d1) || !isValid(d2)) {
    return '';
  }

  const months = Math.abs(differenceInCalendarMonths(d2, d1)) + 1;
  return months.toString();
};

export const NEGOTIATION_PROGRESS_TYPE = {
  /** 未入力 */
  NOT_ENTERED: '00',
  /** 商談中 */
  IN_NEGOTIATION: '01',
  /** 契約成立 */
  SATISFIED: '02',
  /** 契約不成立 */
  UNSATISFIED: '03',
  /** 利用中 */
  USING: '04',
  /** 提案前 */
  BEFORE_PROPOSAL: '05',
};

export const OTHER_PRODUCT_ACTION_STATUS_TYPE = {
  /** 未選択 */
  NOT_ENTERED: '00',
  /** 可能性あり */
  HAVE_POSSIBILITY: '81',
  /** 対応中 */
  IN_PROCESS: '01',
  /** 対応完了 */
  COMPLETE: '91',
};

/** メールパーミッション区分 */
export const MAIL_PERMISSION_TYPE = {
  /** 送信しない */
  NOT_SEND: '',
  /** 拒否 */
  DENY: '00',
  /** 承諾 */
  CONSENT: '01',
  /** 拒否（遠隔） */
  DENY_REMOTE: '10',
  /** 承諾（遠隔） */
  CONSENT_REMOTE: '11',
  /** 回答待ち（遠隔） */
  WAITING_FOR_ANSWER: '19',
} as const;
export type MailPermissionType = typeof MAIL_PERMISSION_TYPE[keyof typeof MAIL_PERMISSION_TYPE];

/** 送信方法 */
export const SEND_TYPE = {
  /** 個別 */
  UNICAST: '0',
  /** 一斉 */
  MULTICAST: '1',
  /** 許諾 */
  OPT_IN: '2',
} as const;
export type SendMethodType = typeof SEND_TYPE[keyof typeof SEND_TYPE];

/** オプトインメールタイプ */
export const OPT_IN_MAIL_TYPE = {
  /** 新規登録 */
  NEW: '0',
  /** 情報更新 */
  UPDATE: '1',
} as const;
export type OptInMailType = typeof OPT_IN_MAIL_TYPE[keyof typeof OPT_IN_MAIL_TYPE];

/** 処理区分 */
export const PROCESSING_TYPE = {
  /** 下書き */
  DRAFT: '0',
  /** 送信 */
  SEND: '1',
} as const;
export type ProcessingType = typeof PROCESSING_TYPE[keyof typeof PROCESSING_TYPE];

/** 主副関係区分 */
export const SUBORDINATION_TYPE = {
  /** SBとの組み合わせ店舗 */
  COMBINED_STORE_WITH_SB: '0',
  /** YMとの組み合わせ店舗 */
  COMBINED_STORE_WITH_YM: '1',
};

/** 企業区分 */
export const COMPANY_CFC = {
  /** SB */
  SB: '1',
  /** YM */
  YM: '4',
};

/** モバイル契約形態区分 */
export const MOBILE_CONTRACT_TYPE = {
  /** 未選択 */
  NOT: '00',
  /** 純新規 */
  NEW: '01',
  /** 乗換（転入） */
  MNP: '02',
  /** 機変 */
  MODEL_CHANGE: '03',
  /** 契約変更 */
  CONTRACT_CHANGE: '04',
  /** 番号移行 */
  MSN_TRANSFER: '05',
  /** 操作説明 */
  OPERATION_EXPLANATION: '06',
  /** 情変 */
  INFO_CHANGE: '07',
  /** 解約阻止 */
  CANCELLATION_PREVENTION: '08',
  /** 転出阻止 */
  MOVING_OUT_PREVENTION: '09',
  /** SIM交換 */
  SIM_CHANGE: '10',
  /** SIM再発行 */
  SIM_REPUBLISH: '11',
  /** その他 */
  OTHER: '99',
};

/** 事前準備架電 */
export const BEF_CALL_TYPE = {
  /** 未実施 */
  NOT_IMPLEMENTED: '0',
  /** 実施済 */
  PERFORMED: '1',
  /** 不要 */
  UN_NECESSARY: '2',
  /** 再架電 */
  RE_CALL: '3',
};

/** 事前準備クルーヒアリング */
export const HEARING_TYPE = {
  /** 未実施 */
  NOT_IMPLEMENTED: '0',
  /** 実施済 */
  PERFORMED: '1',
  /** 不要 */
  UN_NECESSARY: '2',
  /** 対象外 */
  NOT_APPLICABLE: '9',
};

/** 事前準備照会 */
export const REF_AGREE_STATUS_TYPE = {
  /** 同意する */
  CONSENT: '0',
  /** 同意しない */
  DISAGEEMENT: '1',
  /** 未確認 */
  UN_CONFIRMED: '2',
  /** 対象外 */
  NOT_APPLICABLE: '3',
};

/** 事前の動画視聴有無フラグ */
export const WATCH_VIDEO_FLG_TYPE = {
  /** 未実施 */
  NOT_IMPLEMENTED: '0',
  /** 済 */
  DONE: '1',
  /** 一部済 */
  PARTIALLY_DONE: '2',
};

/** 事前顧客照会同意ステータス */
export const REF_CUSTOMER_AGREE_STATUS_TYPE = {
  /** 実施済 */
  PERFORMED: '0',
  /** 未同意 */
  DISAGEEMENT: '1',
  /** 未実施 */
  NOT_IMPLEMENTED: '2',
  /** - */
  NOT_APPLICABLE: '3',
};

/** 予約情報ステータス */
export const STATUS_CD_TYPE = {
  /** 済 */
  DONE: '06',
};

/** 取扱商材区分 */
export const HNDL_ITM_CFC_TYPE = {
  /** 来店予約 */
  VISIT_RESERVATION: '47',
};

/** 初回経路区分 */
export const FIRST_ROUTE_KBN = {
  /** 先頭2桁 */
  FIRST_TOW_DIGITS: {
    /** クルー */
    CREW: 'CR',
  },
};

/** 当日変更フラグ */
export const TODAY_CHG_FLG = {
  /** 当日変更なし */
  NOT_TODAY: '0',
  /** 当日変更あり */
  TODAY: '1',
};

export const WEB_INDENTIFICATION_TYPE = {
  /** クルー */
  CREW_NOT_TODAY: '00',
  /** 当日クルー */
  CREW_TODAY: '01',
  /** WEB */
  WEB_NOT_TODAY: '10',
  /** 当日クルー */
  WEB_TODAY: '11',
};

/** 料金プラン（S） */
export const PRICE_PLAN_TYPE = {
  /** 未選択 */
  NOT_ENTERED: '00',
  /** 基本プラン（音声） */
  AUDIO: '01',
  /** 基本プラン（データ） */
  DATA: '02',
  /** 基本プラン（みまもりケータイ/キッズフォン） */
  WATCH_OVER_KIDS_PHONE: '03',
  /** スマホデビュープラン */
  SMART_PHONE_DEBUT_PLAN: '04',
  /** その他 */
  OTHER: '05',
  /** 未定 */
  TO_BE_DECIDED: '06',
  /** スマホデビュープラン＋ */
  SMART_PHONE_DEBUT_PLAN_PULS: '07',
};

/** 見込顧客モバイル料金プラン区分（Yｍ） */
export const YM_PRICE_PLAN_TYPE = {
  /** 未選択 */
  NOT_ENTERED: '00',
  /** （新規受付終了）シンプルS */
  SIMPLE_S: '01',
  /** （新規受付終了）シンプルM */
  SIMPLE_M: '02',
  /** （新規受付終了）シンプルL */
  SIMPLE_L: '03',
  /** （新規受付終了）ケータイプランSS */
  CELL_PHONE_PLAN_SS: '04',
  /** シェアプラン */
  SHARE_PLAN: '05',
  /** PocketWi-Fiプラン2 */
  POCKET_WI_FI_PLAN_TWO: '06',
  /** （新規受付終了）データプランL/S */
  DATA_PLAN_L_S: '07',
  /** （新規受付終了）スマホプランS */
  SMART_PHONE_PLAN_S: '08',
  /** （新規受付終了）スマホプランM */
  SMART_PHONE_PLAN_M: '09',
  /** （新規受付終了）スマホプランR */
  SMART_PHONE_PLAN_R: '10',
  /** （新規受付終了）スマホプランL */
  SMART_PHONE_PLAN_L: '11',
  /** （新規受付終了）PocketWi-Fiプラン2ライト */
  POCKET_WI_FI_PLAN_TWO_LIGHT: '12',
  /** （新規受付終了）旧PocketWi-Fiプラン */
  OLD_POCKET_WI_FI_PLAN: '13',
  /** （新規受付終了）ケータイプランSプラン（PHS） */
  CELL_PHONE_PLAN_S_PHS: '14',
  /** シンプル2 S */
  SIMPLE_TWO_S: '15',
  /** シンプル2 M */
  SIMPLE_TWO_M: '16',
  /** シンプル2 L */
  SIMPLE_TWO_L: '17',
  /** （新規受付終了）ケータイベーシックプランSS */
  CELL_PHONE_BASIC_PLAN_SS: '18',
  /** 未定 */
  TO_BE_DECIDED: '88',
  /** その他 */
  OTHER: '99',
};

/** パケットサービス（S） */
export const PACKET_DSCT_SERVICE_TYPE = {
  /** 未選択 */
  NOT_ENTERED: '00',
  /** （新規受付停止）データプランメリハリ無制限 */
  DATA_PLAN_MEIRIHARI_UNLIMITED: '01',
  /** データプランミニフィット＋ */
  DATA_PLAN_MINI_FIT_PULS: '02',
  /** データプランメリハリ */
  DATA_PLAN_MERIHARI: '03',
  /** データプランミニフィット */
  DATA_PLAN_MINI_FIT: '04',
  /** データプラン50GB＋ */
  DATA_PLAN_FIFTY_GB_PULS: '05',
  /** データプランミニ */
  DATA_PLAN_MINI: '06',
  /** データプラン1GB */
  DATA_PLAN_ONE_GB: '07',
  /** データプラン1GB+1GBプラス */
  DATA_PLAN_ONE_GB_PULS: '08',
  /** データプラン100MB */
  DATA_PLAN_HUNDRED_MB: '09',
  /** シェア（子回線） */
  SHARE_CHILD_LINE: '10',
  /** その他パケット */
  OTHER_PACKET: '11',
  /** 不要 */
  UN_NECESSARY: '12',
  /** 未定 */
  TO_BE_DECIDED: '13',
  /** データプラン4GB */
  DATA_PLAN_FOUR_GB: '14',
  /** データプラン20GB */
  DATA_PLAN_TWENTY_GB: '15',
  /** データプランペイトク30 */
  DATA_PLAN_PAY_TOKU_THIRTY: '16',
  /** データプランペイトク50 */
  DATA_PLAN_PAY_TOKU_FIFTY: '17',
  /** データプランペイトク無制限 */
  DATA_PLAN_PAY_TOKU_UNLIMITED: '18',
  /** データプランメリハリ無制限＋ */
  DATA_PLAN_MERIHARI_UNLIMITED_PULS: '19',
};

/** 外部連携システムコード */
export const SYSTEM_CD = {
  /** GINIE */
  GINIE: 'M00002',
  /** 来店予約 */
  VISIT_RESERVATION: 'M00500',
  /** 料金シミュレータ */
  FEE_SIMULATOR: 'M00807',
  /** BB-GINIE */
  BB_GINIE: 'M00083',
  /** エリア検索 */
  AREA_SEARCH: 'M00083_AREA',
  /** ヒアナビ */
  HEAR_NAVI: 'M00843',
  /** スケ管 */
  SCHEDULE: 'M00843_SCHEDULE',
};

/**
 * 前半終了回数
 */
export const MOBILE_INSTALL_EARLY_LAST_COUNT = {
  /** 1～24回 */
  TWENTY_FOUR: '24',
  /** 1～12回 */
  TWELVE: '12',
} as const;
export type PcmCdDivision = typeof MOBILE_INSTALL_EARLY_LAST_COUNT[keyof typeof MOBILE_INSTALL_EARLY_LAST_COUNT];
/**
 * 中間終了回数
 */
export const MOBILE_INSTALL_MIDDLE_LAST_COUNT = '12';

/**
 * チェック状態
 * チェックボックス・ラジオなどチェック状態を表す
 */
export const CHECK_FLG = {
  ON: '1',
  OFF: '0',
};

/** LINEステータス */
export const LINE_CONTACT_TYPE = {
  /** LINE連絡可 */
  CONTACT_AVAILABLE: '0',
  /** LINE連絡済 */
  CONTACTED: '1',
  /** LINE要確認 */
  CONFIRMATION_REQUIRED: '2',
  /** LINE連絡中 */
  CONTACTING: '3',
  /** 対象外 */
  NOT_APPLICABLE: undefined,
};

/** 「ヒアリングQR」ステータス */
export const HEARING_QA_TYPE = {
  /** 回答無 */
  NOT_ANSWERED: '0',
  /** 回答有 */
  ANSWERED: '1',
  /** 対象外 */
  NOT_APPLICABLE: '9',
};

export const removeProductVariableOfMobile = (
  selectedCategoryType: string,
  registrationProductList: Array<RegistrationProduct>,
): Array<RegistrationProduct> => {
  return nonMobileCategoryType.includes(selectedCategoryType)
    ? registrationProductList.filter((product) => displayItemIdListNeedRemoved.indexOf(product.displayItemId) === -1)
    : registrationProductList;
};

export const displayItemIdListNeedRemoved: string[] = [
  DISPLAY_ITEM_ID.MOBILE_UPD_YEAR_MONTH,
  DISPLAY_ITEM_ID.MOBILE_INSTALL_MONTHLY_PAYMENT,
  DISPLAY_ITEM_ID.MOBILE_INSTALL_END_YEAR_MONTH,
  DISPLAY_ITEM_ID.USING_MOBILE_INSTALL_MONTHLY_PAYMENT_EARLY,
  DISPLAY_ITEM_ID.USING_MOBILE_INSTALL_EARLY_LAST_COUNT,
  DISPLAY_ITEM_ID.USING_MOBILE_KIND_NAME,
  DISPLAY_ITEM_ID.SUBSCRIPTION_BENEFITS,
  DISPLAY_ITEM_ID.CAMPAIGN_START_MONTH,
  DISPLAY_ITEM_ID.USING_MOBILE_INSTALL_END_YEAR_MONTH_EARLY,
  _DISPLAY_ITEM_ID.MOBILE_BALANCE,
];

export const nonMobileCategoryType: string[] = [
  COMMODITY_CATEGORY_TYPE.SOFTBANK_HIKARI,
  COMMODITY_CATEGORY_TYPE.SOFTBANK_HIKARI_PLUS,
  COMMODITY_CATEGORY_TYPE.SOFTBANK_AIR,
  COMMODITY_CATEGORY_TYPE.ELECTRICITY,
  COMMODITY_CATEGORY_TYPE.HOME_PHONE,
  COMMODITY_CATEGORY_TYPE.DATA_BOX,
  COMMODITY_CATEGORY_TYPE.BASKET_LIVE,
  COMMODITY_CATEGORY_TYPE.SMARTPHONE_SET_SUPPORT,
  COMMODITY_CATEGORY_TYPE.ALL_OTHER,
];

/**
 * 許諾メール再送信フラグ
 */
export const OPT_IN_MAIL_RESEND_FLG = {
  /** 送信しない */
  NOT_SEND: '0',
  /** 送信する */
  SEND: '1',
} as const;
export type OptinMailResendFlg = typeof OPT_IN_MAIL_RESEND_FLG[keyof typeof OPT_IN_MAIL_RESEND_FLG];

/**
 * 遷移元画面の種別
 */
export const TRANSITION_SOURCE_PAGE_STATE = {
  /**
   * ダッシュボードからの遷移
   */
  DASHBOARD: 'innerSiteDashboard',
  /**
   * 商談一覧からの遷移
   */
  SEARCH_RESULT: 'innerSiteSearchResult',
  /**
   * お客さま情報からの遷移
   */
  CUSTOMER_DETAIL: 'innerSiteCustomerDetail',
  /**
   * サマリーからの遷移
   */
  SUMMARY: 'innerSiteSummary',
  /**
   * 外部サイトからの遷移
   */
  EXTERNAL: 'external',
  /**
   * 法人顧客一覧からの遷移
   */
  CORPORATE_CUSTOMER_LIST: 'innerSiteCorporateCustomerList',
  /**
   * 顧客一覧からの遷移
   */
  CUSTOMER_INFO_LIST: 'innerSiteCustomerInfoList',
} as const;
export type TransitionSourcePageType = typeof TRANSITION_SOURCE_PAGE_STATE[keyof typeof TRANSITION_SOURCE_PAGE_STATE];

export type DataLayer = 'customer' | 'negotiation' | 'product' | 'action' | 'customerDetailModal' | 'summaryModal';

export type ErrorMessageType = {
  /**
   * エラー概要のタイトル
   */
  errorTitle: string;
  /**
   * エラー補足情報
   */
  errorMessageList: string[];
};

/**
 * backendとの疎通が想定外の原因により失敗した場合に使用するメッセージの共通文言
 */
export const API_EXCEPTION_MSG = `API通信時に異常が発生しました`;

export const notfoundTitleBaseStr = `{0}が見つかりませんでした`;
const notfoundMessageBaseStr = `指定された{0}が削除されています`;
const directingNextActionMessageBaseStr = `もう一度商談一覧から検索しなおしてください`;
export const displayCustomerInfo = 'お客さま情報';
export const displayNegotiationInfo = '商談情報';
export const displayProductInfo = '商品情報';
export const displayActionInfo = 'アクション情報';
const DATA_NOT_FOUND_MESSAGE_MAP: ReadonlyMap<DataLayer, ErrorMessageType> = new Map<DataLayer, ErrorMessageType>([
  [
    'customer',
    {
      errorTitle: getReplacedStringByParams(notfoundTitleBaseStr, displayCustomerInfo),
      errorMessageList: [getReplacedStringByParams(notfoundMessageBaseStr, displayCustomerInfo), directingNextActionMessageBaseStr],
    },
  ],
  [
    'negotiation',
    {
      errorTitle: getReplacedStringByParams(notfoundTitleBaseStr, displayNegotiationInfo),
      errorMessageList: [getReplacedStringByParams(notfoundMessageBaseStr, displayNegotiationInfo), directingNextActionMessageBaseStr],
    },
  ],
  [
    'product',
    {
      errorTitle: getReplacedStringByParams(notfoundTitleBaseStr, displayProductInfo),
      errorMessageList: [getReplacedStringByParams(notfoundMessageBaseStr, displayProductInfo), directingNextActionMessageBaseStr],
    },
  ],
  [
    'action',
    {
      errorTitle: getReplacedStringByParams(notfoundTitleBaseStr, displayActionInfo),
      errorMessageList: [getReplacedStringByParams(notfoundMessageBaseStr, displayActionInfo), directingNextActionMessageBaseStr],
    },
  ],
  [
    'customerDetailModal',
    {
      errorTitle: getReplacedStringByParams(notfoundTitleBaseStr, displayCustomerInfo),
      errorMessageList: [getReplacedStringByParams(notfoundMessageBaseStr, displayCustomerInfo)],
    },
  ],
  [
    'summaryModal',
    {
      errorTitle: getReplacedStringByParams(notfoundTitleBaseStr, displayCustomerInfo),
      errorMessageList: [getReplacedStringByParams(notfoundMessageBaseStr, displayCustomerInfo)],
    },
  ],
]);

export const getDataNotFoundMessageObject = (key: DataLayer): ErrorMessageType =>
  DATA_NOT_FOUND_MESSAGE_MAP.get(key) ?? {
    errorTitle: '',
    errorMessageList: [],
  };

export const SESSION_STORAGE_NEGOTATION_KEYS = {
  SORT_TYPE: 'sort-business',

  CURRENT_PAGE: 'current-page-business',

  PAGING_TABLE: 'paging-table',

  API_UPDATE_INDEX: 'api-update-index',
};

export const getStorageValueByKey = (key: string) => {
  return window.sessionStorage.getItem(key) as string;
};

export const setStorageValueByKey = (key: string, value: any) => {
  let _value = value;
  if (typeof value !== 'string') {
    _value = JSON.stringify(value);
  }
  window.sessionStorage.setItem(key, _value);
};

export const removeKeysStorage = () => {
  const arrKeys = [
    SESSION_STORAGE_NEGOTATION_KEYS.API_UPDATE_INDEX,
    SESSION_STORAGE_NEGOTATION_KEYS.CURRENT_PAGE,
    SESSION_STORAGE_NEGOTATION_KEYS.PAGING_TABLE,
    SESSION_STORAGE_NEGOTATION_KEYS.SORT_TYPE,
  ];
  arrKeys.forEach((item) => sessionStorage.removeItem(item));
};

export const EVENT_LISTENER_KEYS = {
  BEFORE_UNLOAD: 'beforeunload',
};

export const BRANCH_CONDITTION_KEY = {
  COMMODITY_CATEGORY_TYPE: 'commodityCategoryType',
  UNDISPFLAG: 'undispFlg',
  NEGOTIATIONRESULTTYPE: 'negotiationResultType',
  RESURRECTION_FLG: 'resurrectionFlg',
  ACTION_DATE: 'actionDate',
  ACTION_INFOR: 'actionInfo',
  MOBILE_CONTRACT_TYPE: 'mobileContractType',
  PRODUCT_INFO: 'productInfo',
  DUMMY_FLG: 'dummyFlg',
  ACTION_TYPE: 'actionType',
  DOC_TYPE: 'docType',
  CONTRACT_ACCURACY_TYPE: 'contractAccuracyType',
};

export const NON_FILTER_BRANCHCONDITTION_KEYS: string[] = [
  BRANCH_CONDITTION_KEY.UNDISPFLAG,
  BRANCH_CONDITTION_KEY.ACTION_INFOR,
  BRANCH_CONDITTION_KEY.PRODUCT_INFO,
  BRANCH_CONDITTION_KEY.DUMMY_FLG,
];

export enum GTM_BUTTON_ID {
  EMPLOYEE_SEARCH_BUTTON_ID = 'employee-search-button',
  CREW_OPEN_MODAL_UPDATE_ACTION_LIST_BUTTON_ID = 'crew-open-modal-update-action-list-button',
  CREW_UPDATE_ACTION_LIST_BUTTON_ID = 'crew-update-action-list-button',
  CREW_CUSTOMER_DETAIL_HISTORY_BUTTON = 'crew-customer-detail-history-button',
}

export const SALE_MANCD_NAME_KEY = {
  CLOSING_SALE_MANCD: 'closingSalesmanName',
  MAIN_CLOSING_SALE_MANCD: 'mainClosingSalesmanName',
};

/**
 * 文字列型の日付から指定のフォーマットの日付型へ変換
 * @param stringDate
 * @param fromFormat
 * @returns Date | undefined
 * 日付変換に失敗した場合はundefinedを返却します
 */
export const stringDateToFormat = (stringDate: string, fromFormat: string): Date | undefined => {
  const date = parse(stringDate, fromFormat, new Date(), { locale: ja });
  if (isInvalidDate(date)) {
    return undefined;
  }
  return date;
};
/**
 * 日付を加算します
 * @param date
 * @param amount
 * @returns Date
 */
export const addDate = (date: Date, amount: number) => {
  return addDays(date, amount);
};

/**
 * 日付を比較し、第一引数が第二引数よりも未来または同日であるかを判定します
 * @param date
 * @param dateCompare
 * @param amount
 * @returns Date
 * ※ 第一引数が第二引数よりも未来日の場合はfalse,それ以外はtrueを返します
 */
export const isPastOrEqualDay = (date: Date, dateCompare: Date) => {
  return isPastDay(date, dateCompare) || isEqualDay(date, dateCompare);
};

export const convertDataSalesManName = (list: SmallCategory[]): SalesmanInfo[] => {
  return uniqWith(list, (obj1: SmallCategory, obj2: SmallCategory) => {
    return obj1.smallCategoryCd === obj2.smallCategoryCd && obj1.smallCategoryCdName === obj2.smallCategoryCdName;
  }).map(({ smallCategoryCd, smallCategoryCdName }) => ({
    salesmanCd: smallCategoryCd,
    salesmanName: smallCategoryCdName,
  }));
};

/**
 * Determines the commodity brand code based on provided companyCfc value.
 * @param companyCfc
 * @returns string
 * ※ Return SB if companyCfc is 1, otherwise returns YM
 */
export const getCommodityBrandByCompanyCfc = (companyCfc: string): string => {
  return COMMODITY_BRAND.SB === companyCfc ? 'SB' : 'YM';
};

/**
 * Combines companyCfc and originalName into a single string
 * @param companyCfc
 * @param originalName
 * @returns string
 * ※ Return combined string by formatted (YM)companyName or (SB)companyName
 */
export const getCompanyCfcDisplayName = (companyCfc: string, originalName: string): string => {
  return `(${getCommodityBrandByCompanyCfc(companyCfc)})${originalName}`;
};
export interface SummaryFilterType {
  code: string;
  label: string;
  title: string;
  type: string;
  displayOrder?: number;
}

export const MOBILE_SUMMARY_FILTER_TYPE: {
  [key: string]: SummaryFilterType;
} = {
  '01': {
    code: '01',
    label: '新規登録',
    title: 'モバイル',
    type: 'mobile',
  },
  '04': {
    code: '04',
    label: '機種変更',
    title: 'モバイル',
    type: 'mobile',
  },
  '06': {
    code: '06',
    label: '情報変更',
    title: 'モバイル',
    type: 'mobile',
  },
  MD: {
    code: 'MD',
    label: 'サービス変更',
    title: 'モバイル',
    type: 'mobile',
  },
};

export const ELECTRIC_SUMMARY_FILTER_TYPE: {
  [key: string]: SummaryFilterType;
} = {
  '74': {
    code: '74',
    label: '電力申込',
    title: 'おうちでんき',
    type: 'homeElectricity',
  },
  '87': {
    code: '87',
    label: '北陸・九州でんきセット',
    title: 'おうちでんき',
    type: 'homeElectricity',
  },
  // '94': {
  //   code: '94',
  //   label: '電力申込',
  //   title: 'おうちでんき',
  //   type: 'homeElectricity',
  // },
};

export const INTERNET_SUMMARY_FILTER_TYPE: {
  [key: string]: SummaryFilterType;
} = {
  '0501': {
    code: '0501',
    label: 'ソフトバンク光/新規',
    title: 'インターネット・固定電話',
    type: 'internet',
    displayOrder: 1,
  },
  '0502': {
    code: '0502',
    label: 'ソフトバンク光/転用',
    title: 'インターネット・固定電話',
    type: 'internet',
    displayOrder: 2,
  },
  '0503': {
    code: '0503',
    label: 'ソフトバンク光/事業者変更',
    title: 'インターネット・固定電話',
    type: 'internet',
    displayOrder: 3,
  },
  '0504': {
    code: '0504',
    label: 'ソフトバンク光/光回線再利用',
    title: 'インターネット・固定電話',
    type: 'internet',
    displayOrder: 4,
  },
  '0505': {
    code: '0505',
    label: 'ソフトバンク光/サービス変更（SB Air）',
    title: 'インターネット・固定電話',
    type: 'internet',
    displayOrder: 6,
  },
  '0506': {
    code: '0506',
    label: 'ソフトバンク光/サービス変更（BBISP）',
    title: 'インターネット・固定電話',
    type: 'internet',
    displayOrder: 7,
  },
  '0507': {
    code: '0507',
    label: 'ソフトバンク光/サービス変更（SB光＋）',
    title: 'インターネット・固定電話',
    type: 'internet',
    displayOrder: 5,
  },
  '1301': {
    code: '1301',
    label: 'SoftBank 光＋/新規',
    title: 'インターネット・固定電話',
    type: 'internet',
    displayOrder: 8,
  },
  '1302': {
    code: '1302',
    label: 'SoftBank 光＋/サービス変更（SB 光）',
    title: 'インターネット・固定電話',
    type: 'internet',
    displayOrder: 9,
  },
  '1303': {
    code: '1303',
    label: 'SoftBank 光＋/サービス変更（SB Air）',
    title: 'インターネット・固定電話',
    type: 'internet',
    displayOrder: 10,
  },
  '1304': {
    code: '1304',
    label: 'SoftBank 光＋/光回線再利用（コラボ光）',
    title: 'インターネット・固定電話',
    type: 'internet',
    displayOrder: 11,
  },
  '1305': {
    code: '1305',
    label: 'SoftBank 光＋/サービス変更（BBISP）',
    title: 'インターネット・固定電話',
    type: 'internet',
    displayOrder: 12,
  },
  '0601': {
    code: '0601',
    label: 'ＳＢＡｉｒ/新規',
    title: 'インターネット・固定電話',
    type: 'internet',
    displayOrder: 13,
  },
  '0602': {
    code: '0602',
    label: 'ＳＢＡｉｒ/機変',
    title: 'インターネット・固定電話',
    type: 'internet',
    displayOrder: 14,
  },
  '0603': {
    code: '0603',
    label: 'ＳＢＡｉｒ/サービス変更（SB 光）',
    title: 'インターネット・固定電話',
    type: 'internet',
    displayOrder: 15,
  },
  '0604': {
    code: '0604',
    label: 'ＳＢＡｉｒ/サービス変更（SB光＋）',
    title: 'インターネット・固定電話',
    type: 'internet',
    displayOrder: 16,
  },
  '0701': {
    code: '0701',
    label: 'おうちの電話/新規',
    title: 'インターネット・固定電話',
    type: 'internet',
    displayOrder: 17,
  },
};

export const REPORT_SECTIONS_COMMON: {
  [key: string]: {
    [key: string]: string;
  };
} = {
  CARD: {
    className: 'report-cards__item-card',
    key: 'CARD',
  },
  TABLE: {
    className: 'report-table__item-td',
    key: 'TABLE',
  },
};

export const SCREEN_NAME_COMMON: { [key: string]: string } = {
  dashboard: SCREEN.DASHBOARD.NAME,
  underNegotiation: 'レポート商談中',
  pendingNegotiation: 'レポート長期保留',
  visitSummary: '来店予約',
  dashboardFilter: 'ダッシュボード_絞り込み',
};

export const REPORT_SCREEN_NAME_COMMON: { [key: string]: string } = {
  underNegotiationPeriod: 'レポート商談中',
  underNegotiationAction: 'レポート商談中',
  underNegotiationProd: 'レポート商談中',
  pendingNegotiation: 'レポート長期保留',
  pendingNegotiationAction: 'レポート長期保留',
};

export const PENDING_NEGOTIATION_TAB_KEY: { [key: string]: string } = {
  pendingNegotiation: 'pendingNegotiation',
  pendingNegotiationAction: 'pendingNegotiationAction',
};

export const FILTER_NEW_DRAWER_SCREEN_NAME_ADD: { [key: string]: string } = {
  dashboard: '絞り込み',
  underNegotiation: '_絞り込み',
};

export const FILTER_NEW_MODAL_SCREEN_NAME_ADD: { [key: string]: string } = {
  dashboard: '_表示店舗',
  underNegotiation: '_表示店舗',
};

export const FILTER_NEW_SCREEN_KEY: { [key: string]: string } = {
  dashboard: 'dashboard',
  underNegotiation: 'underNegotiation',
};

export const FILTER_SECTIONS_KEY: { [key: string]: string } = {
  DRAWER: 'drawer',
  MODAL: 'modal',
  BUTTON: 'button',
};

export const VIST_SUMMARY_REFRESH_KEY: { [key: string]: string } = {
  visitSummary: 'visitSummary',
  dashboard: 'dashboard',
};

export const SCREEN_REFRESH_KEY_COMMON: { [key: string]: string } = {
  dashboard: 'dashboard',
  underNegotiation: 'underNegotiation',
  pendingNegotiation: 'pendingNegotiation',
  ...VIST_SUMMARY_REFRESH_KEY,
};

export const REFRESH_BTN_COMMON: { [key: string]: string } = {
  CLASSNAME: 'refresh-btn__data',
  KEY: 'refresh',
  LABEL: 'リフレッシュ',
};

export const DASHBOARD_MAPPING_COMMON: { [key: string]: { displayName: string } } = {
  doing: {
    displayName: 'レポート_商談中',
  },
  pending: {
    displayName: 'レポート_長期保留',
  },
  done: {
    displayName: 'レポート_商談終了',
  },
};

export const DASHBOARD_CUSTOM_COUNT_MAPPING_COMMON: { [key: string]: { className: string; displayName: string } } = {
  summarySmartphone: {
    className: 'dashboard-to-summary-smartphone',
    displayName: 'カスタムサマリ_スマホ(新規,MNP)_合計',
  },
  summarySBHikari: {
    className: 'dashboard-to-summary-sb-hikari',
    displayName: 'カスタムサマリ_SB光,SBAir_合計',
  },
  summaryPlanned: {
    className: 'dashboard-to-summary-planned',
    displayName: 'カスタムサマリ_架電予定_合計',
  },
};

export const FILTER_MAPPING: { [key: string]: { id: string; displayName: string } } = {
  searchInput: {
    id: 'search-input__spotEvent',
    displayName: '絞り込み',
  },
  searchDisplay: {
    id: 'search-display__spotEvent',
    displayName: '絞り込み表示',
  },
  close: {
    id: 'close__spotEvent',
    displayName: 'バツ',
  },
  cancel: {
    id: 'cancel__spotEvent',
    displayName: 'キャンセル',
  },
  selectStoreFilter: {
    id: 'select-storeFilter__spotEvent',
    displayName: '店舗/店舗フィルタを選択',
  },
};

export const DASHBOARD_HEADER_MAPPING_CREW: { [key: string]: { id: string; displayName: string } } = {
  registerCustomer: {
    id: 'dashboard-register-customer',
    displayName: 'お客さまを登録',
  },
  ...FILTER_MAPPING,
};

export const REPORT_ROW_TABLE_COMMON_MAPPING: { [key: string]: { displayName: string } } = {
  // レポート画面の商材別集計テーブルの列名定義に使うマッピング
  // 同テーブルの表示対象外のキーは入れずに、表示要件が確定したら追加する
  smartphoneNew: {
    displayName: 'HSスマホ_純新規',
  },
  smartphoneTransfer: {
    displayName: 'HSスマホ_番号移行',
  },
  smartphoneChange: {
    displayName: 'HSスマホ_機変',
  },
  smartphoneMnp: {
    displayName: 'HSスマホ_乗換（転入）',
  },
  smartphoneContrChg: {
    displayName: 'HSスマホ_契約変更',
  },
  garakeiNew: {
    displayName: 'HSスマホ以外_純新規',
  },
  garakeiTransfer: {
    displayName: 'HSスマホ以外_番号移行',
  },
  garakeiChange: {
    displayName: 'HSスマホ以外_機変',
  },
  garakeiMnp: {
    displayName: 'HSスマホ以外_乗換（転入）',
  },
  garakeiContrChg: {
    displayName: 'HSスマホ以外_契約変更',
  },
  tabletNew: {
    displayName: 'タブレット_純新規',
  },
  tabletChange: {
    displayName: 'タブレット_機変',
  },
  otherNew: {
    displayName: 'その他（モバイル）_純新規',
  },
  otherTransfer: {
    displayName: 'その他（モバイル）_番号移行',
  },
  otherChange: {
    displayName: 'その他（モバイル）_機変',
  },
  otherMnp: {
    displayName: 'その他（モバイル）_乗換（転入）',
  },
  otherContrChg: {
    displayName: 'その他（モバイル）_契約変更',
  },
  simNew: {
    displayName: 'SIM単体_純新規',
  },
  simTransfer: {
    displayName: 'SIM単体_番号移行',
  },
  simChange: {
    displayName: 'SIM単体_機変',
  },
  simMnp: {
    displayName: 'SIM単体_乗換（転入）',
  },
  simContrChg: {
    displayName: 'SIM単体_契約変更',
  },
  hikariNew: {
    displayName: 'ソフトバンク光_純新規',
  },
  hikariDiverted: {
    displayName: 'ソフトバンク光_転用',
  },
  hikariChange: {
    displayName: 'ソフトバンク光_事業者変更',
  },
  hikariReuse: {
    displayName: 'ソフトバンク光_光回線再利用',
  },
  // [PCM-P-0456-0.SB光＋からのサ変追加]で追加された項目は表示要件に含まれないため、hikariSrvChgAir/hikariSrvChgBbisp/hikariSrvChgAurora は追加しない
  airNew: {
    displayName: 'ソフトバンクAir_純新規',
  },
  airChange: {
    displayName: 'ソフトバンクAir_機変',
  },
  // [PCM-P-0456-0.SB光＋からのサ変追加]で追加された項目は表示要件に含まれないため、airSrvChgHikari/airSrvChgAurora は追加しない
  denwaNew: {
    displayName: 'おうちのでんわ_純新規',
  },
  denkiNew: {
    displayName: 'おうちでんき_純新規',
  },
  dataBoxNew: {
    displayName: 'あんしんデータボックス_新規',
  },
  basketLiveNew: {
    displayName: 'バスケットLIVE_新規',
  },
  smartphoneSetSupportNew: {
    displayName: '店頭スマホサポート（他社）_新規（定額加入／サポート利用）',
  },
};

export const DASHBOARD_HEADER_SPOT_EVENT_MAPPING: {
  [key: string]: {
    [key: string]: GASpotEventState;
  };
} = {
  CREW: Object.keys(DASHBOARD_HEADER_MAPPING_CREW).reduce((acc, cur) => {
    const { id, displayName } = DASHBOARD_HEADER_MAPPING_CREW[cur];
    return {
      ...acc,
      [cur]: {
        id,
        spotEvent: `_ga.spotEvent('${GA_EVENT_CATEGORY.CREW}','${SCREEN.DASHBOARD.NAME}','${displayName}')`,
      },
    };
  }, {}),
  AGENCY: Object.keys(FILTER_MAPPING).reduce((acc, cur) => {
    const { id, displayName } = FILTER_MAPPING[cur];
    // ダッシュボード画面の絞り込みボタンだけGAイベントの引数違うため分岐処理
    const screen = displayName === DASHBOARD_LABEL.NAME ? SCREEN.DASHBOARD.NAME : SCREEN_NAME_COMMON.dashboardFilter;
    return {
      ...acc,
      [cur]: {
        id,
        spotEvent: `_ga.spotEvent('${GA_EVENT_CATEGORY.AGENCY}','${screen}','${displayName}')`,
      },
    };
  }, {}),
  EMPLOYEE: Object.keys(FILTER_MAPPING).reduce((acc, cur) => {
    const { id, displayName } = FILTER_MAPPING[cur];
    // ダッシュボード画面の絞り込みボタンだけGAイベントの引数違うため分岐処理
    const screen = displayName === DASHBOARD_LABEL.NAME ? SCREEN.DASHBOARD.NAME : SCREEN_NAME_COMMON.dashboardFilter;
    return {
      ...acc,
      [cur]: {
        id,
        spotEvent: `_ga.spotEvent('${GA_EVENT_CATEGORY.EMPLOYEE}','${screen}','${displayName}')`,
      },
    };
  }, {}),
};

export const DASHBOARD_CUSTOM_COUNT_SPOT_EVENT_MAPPING: {
  [key: string]: {
    [key: string]: GASpotEventState;
  };
} = {
  CREW: Object.keys(DASHBOARD_CUSTOM_COUNT_MAPPING_COMMON).reduce((acc, cur) => {
    const { className, displayName } = DASHBOARD_CUSTOM_COUNT_MAPPING_COMMON[cur];
    return {
      ...acc,
      [cur]: {
        className,
        spotEvent: `_ga.spotEvent('[CREW]_クルー','${SCREEN.DASHBOARD.NAME}','${displayName}')`,
      },
    };
  }, {}),
  AGENCY: Object.keys(DASHBOARD_CUSTOM_COUNT_MAPPING_COMMON).reduce((acc, cur) => {
    const { className, displayName } = DASHBOARD_CUSTOM_COUNT_MAPPING_COMMON[cur];
    return {
      ...acc,
      [cur]: {
        className,
        spotEvent: `_ga.spotEvent('${GA_EVENT_CATEGORY.AGENCY}','${SCREEN.DASHBOARD.NAME}','${displayName}')`,
      },
    };
  }, {}),
  EMPLOYEE: Object.keys(DASHBOARD_CUSTOM_COUNT_MAPPING_COMMON).reduce((acc, cur) => {
    const { className, displayName } = DASHBOARD_CUSTOM_COUNT_MAPPING_COMMON[cur];
    return {
      ...acc,
      [cur]: {
        className,
        spotEvent: `_ga.spotEvent('${GA_EVENT_CATEGORY.EMPLOYEE}','${SCREEN.DASHBOARD.NAME}','${displayName}')`,
      },
    };
  }, {}),
};

export const LASTEST_SUMMARY_SPOT_EVENT_MAPPING: {
  [key: string]: GASpotEventState;
} = {
  CREW: {
    negotiationTotal: "_ga.spotEvent('[CREW]_クルー','ダッシュボード','アプローチ可能な商談')",
    noneNegotiation: "_ga.spotEvent('[CREW]_クルー','ダッシュボード','商談未登録の顧客')",
    noneProduct: "_ga.spotEvent('[CREW]_クルー','ダッシュボード','商品未登録の商談')",
    ...Object.keys(DASHBOARD_MAPPING_COMMON).reduce((acc, cur) => {
      const { displayName } = DASHBOARD_MAPPING_COMMON[cur];
      return {
        ...acc,
        [cur]: `_ga.spotEvent('[CREW]_クルー','${SCREEN.DASHBOARD.NAME}','${displayName}')`,
      };
    }, {}),
  },
  AGENCY: {
    negotiationTotal: "_ga.spotEvent('[AGENCY]_代理店','ダッシュボード','アプローチ可能な商談')",
    noneNegotiation: "_ga.spotEvent('[AGENCY]_代理店','ダッシュボード','商談未登録の顧客')",
    noneProduct: "_ga.spotEvent('[AGENCY]_代理店','ダッシュボード','商品未登録の商談')",
    ...Object.keys(DASHBOARD_MAPPING_COMMON).reduce((acc, cur) => {
      const { displayName } = DASHBOARD_MAPPING_COMMON[cur];
      return {
        ...acc,
        [cur]: `_ga.spotEvent('${GA_EVENT_CATEGORY.AGENCY}','${SCREEN.DASHBOARD.NAME}','${displayName}')`,
      };
    }, {}),
  },
  EMPLOYEE: {
    negotiationTotal: "_ga.spotEvent('[EMPLOYEE]_営業','ダッシュボード','アプローチ可能な商談')",
    noneNegotiation: "_ga.spotEvent('[EMPLOYEE]_営業','ダッシュボード','商談未登録の顧客')",
    noneProduct: "_ga.spotEvent('[EMPLOYEE]_営業','ダッシュボード','商品未登録の商談')",
    ...Object.keys(DASHBOARD_MAPPING_COMMON).reduce((acc, cur) => {
      const { displayName } = DASHBOARD_MAPPING_COMMON[cur];
      return {
        ...acc,
        [cur]: `_ga.spotEvent('${GA_EVENT_CATEGORY.EMPLOYEE}','${SCREEN.DASHBOARD.NAME}','${displayName}')`,
      };
    }, {}),
  },
};

export const SIDE_NAV_COMMON_MAPPING: { [key: string]: GASpotEventMappingState } = {
  dashboard: {
    className: 'sideNav_dashboard__spotEvent',
    displayName: SCREEN.DASHBOARD.NAME,
  },
  negotiationList: {
    className: 'sideNav_negotiationList__spotEvent',
    displayName: SCREEN.NEGOTIATION_SEARCH_RESULT.NAME,
  },
  underNegotiationPeriod: {
    className: 'sideNav_underNegotiationPeriod__spotEvent',
    displayName: 'レポート_商談中_対応期間別',
  },
  underNegotiationAction: {
    className: 'sideNav_underNegotiationAction__spotEvent',
    displayName: 'レポート_商談中_次のアクション',
  },
  underNegotiationProd: {
    className: 'sideNav_underNegotiationProd__spotEvent',
    displayName: 'レポート_商談中_契約確率',
  },
  pendingNegotiationPending: {
    className: 'sideNav_pendingNegotiationPending__spotEvent',
    displayName: 'レポート_長期保留_保留期間別',
  },
  pendingNegotiationAction: {
    className: 'sideNav_pendingNegotiationAction__spotEvent',
    displayName: 'レポート_長期保留_次のアクション',
  },
  pendingNegotiationProd: {
    className: 'sideNav_pendingNegotiationProd__spotEvent',
    displayName: 'レポート_長期保留_契約確率',
  },
  doneNegotiationResult: {
    className: 'sideNav_doneNegotiationResult__spotEvent',
    displayName: 'レポート_商談終了_商談結果別',
  },
  visitSummary: {
    className: 'sideNav_visitSummary__spotEvent',
    displayName: '来店予約',
  },
  manualLink: {
    className: 'sideNav_manualLink__spotEvent',
    displayName: 'マニュアル',
  },
};

export const PRODUCT_COMMON_ACTION_MAPPING: { [key: string]: { className: string; displayName: string; screen: string } } = {
  addProductBtn: {
    className: 'productCreate-addProductBtn',
    displayName: 'プラス',
    screen: '商品の追加',
  },
  duplicateProductBtn: {
    className: 'productCreate-duplicateProductBtn',
    displayName: '商品を複製',
    screen: '商品の追加',
  },
  backToNegotiationBtn: {
    className: 'productEdit-backToNegotiationBtn',
    displayName: '商談詳細へもどる',
    screen: '商品の編集',
  },
};

export const PRODUCT_COMMON_ACTION_SPOT_EVENT_MAPPING: {
  [key: string]: GASpotEventState;
} = {
  ...Object.keys(PRODUCT_COMMON_ACTION_MAPPING).reduce((acc, cur) => {
    const { displayName, className, screen } = PRODUCT_COMMON_ACTION_MAPPING[cur];
    return {
      ...acc,
      [cur]: {
        className,
        spotEvent: `_ga.spotEvent('[CREW]_クルー','${screen}','${displayName}')`,
      },
    };
  }, {}),
};

export const PRODUCT_FORM_ACTIONS_MAPPING: {
  [key: string]: { [subKey: string]: { className: string; displayName: string; screen: string } };
} = {
  deleteProductBtn: {
    create: {
      className: 'productCreate-deleteProductBtn',
      displayName: 'この商品を削除',
      screen: '商品の追加',
    },
    edit: {
      className: 'productEdit-deleteProductBtn',
      displayName: 'この商品を削除',
      screen: '商品の編集',
    },
  },
  launchAreaCheckModalBtn: {
    create: {
      className: 'productCreate-launchAreaCheckModalBtn',
      displayName: 'エリアチェック',
      screen: '商品の追加',
    },
    edit: {
      className: 'productEdit-launchAreaCheckModalBtn',
      displayName: 'エリアチェック',
      screen: '商品の編集',
    },
  },
  saveProductBtn: {
    create: {
      className: 'productCreate-saveProductBtn',
      displayName: '保存',
      screen: '商品の追加',
    },
    edit: {
      className: 'productEdit-saveProductBtn',
      displayName: '保存',
      screen: '商品の編集',
    },
  },
  cancelProductBtn: {
    create: {
      className: 'productCreate-cancelProductBtn',
      displayName: 'キャンセル',
      screen: '商品の追加',
    },
    edit: {
      className: 'productEdit-cancelProductBtn',
      displayName: 'キャンセル',
      screen: '商品の編集',
    },
  },
};

export const PRODUCT_FORM_ACTIONS_SPOT_EVENT_MAPPING: {
  [key: string]: {
    [subKey: string]: GASpotEventState;
  };
} = {
  ...Object.keys(PRODUCT_FORM_ACTIONS_MAPPING).reduce((acc, cur) => {
    return {
      ...acc,
      [cur]: Object.keys(PRODUCT_FORM_ACTIONS_MAPPING[cur]).reduce((subAcc, subCur) => {
        const { className, displayName, screen } = PRODUCT_FORM_ACTIONS_MAPPING[cur][subCur];
        return {
          ...subAcc,
          [subCur]: {
            className,
            spotEvent: `_ga.spotEvent('[CREW]_クルー','${screen}','${displayName}')`,
          },
        };
      }, {}),
    };
  }, {}),
};

export const SELECT_ACTION_MODAL_MAPPING: {
  [key: string]: GASpotEventState;
} = {
  ...Object.keys(ACTION_TAG).reduce((acc, cur) => {
    const { name: displayName } = ACTION_TAG[cur];
    return {
      ...acc,
      [cur]: {
        className: ACTION_TAG_CLASSNAMES[cur],
        spotEvent: `_ga.spotEvent('[CREW]_クルー','商談詳細_追加アクションの選択','${displayName}')`,
      },
    };
  }, {}),
};

export const ACTION_FORM_BUTTONS_MAPPING: {
  [key: string]: { [subKey: string]: { className: string; displayName: string; screen: string } };
} = {
  actionSaveBtn: {
    create: {
      className: 'actionSaveBtn',
      displayName: '保存',
      screen: 'アクション追加',
    },
    edit: {
      className: 'actionSaveBtn',
      displayName: '保存',
      screen: 'アクションの編集',
    },
  },
  actionCancelBtn: {
    create: {
      className: 'actionCancelBtn',
      displayName: 'キャンセル',
      screen: 'アクション追加',
    },
    edit: {
      className: 'actionCancelBtn',
      displayName: 'キャンセル',
      screen: 'アクションの編集',
    },
  },
  actionBackToNegotiationBtn: {
    create: {
      className: 'actionBackToNegotiationBtn',
      displayName: '商談詳細へもどる',
      screen: 'アクション追加',
    },
    edit: {
      className: 'actionBackToNegotiationBtn',
      displayName: '商談詳細へもどる',
      screen: 'アクションの編集',
    },
  },
  actionDeleteBtn: {
    edit: {
      className: 'actionDeleteBtn',
      displayName: 'このアクションを削除',
      screen: 'アクションの編集',
    },
  },
};

export const ACTION_FORM_BUTTONS_SPOT_EVENT_MAPPING: {
  [key: string]: { [subKey: string]: { [subSubKey: string]: GASpotEventState } };
} = {
  ...Object.keys(ACTION_FORM_BUTTONS_MAPPING).reduce((acc, cur) => {
    return {
      ...acc,
      [cur]: {
        ...Object.keys(ACTION_TAG).reduce((subAcc, subCur) => {
          return {
            ...subAcc,
            [subCur]: {
              ...Object.keys(ACTION_FORM_BUTTONS_MAPPING[cur]).reduce((subSubAcc, subSubCur) => {
                const { className, displayName, screen } = ACTION_FORM_BUTTONS_MAPPING[cur][subSubCur];
                return {
                  ...subSubAcc,
                  [subSubCur]: {
                    className,
                    spotEvent: `_ga.spotEvent('[CREW]_クルー','${screen}_${ACTION_TAG[subCur].name}','${displayName}')`,
                  },
                };
              }, {}),
            },
          };
        }, {}),
      },
    };
  }, {}),
};

export const SIDE_NAV_CREW_MAPPING: { [key: string]: GASpotEventMappingState } = {
  ...SIDE_NAV_COMMON_MAPPING,
  mail: {
    className: 'sideNav_mail__spotEvent',
    displayName: SCREEN.MAIL_TOP.NAME,
  },
};

export interface GASpotEventMappingState {
  className: string;
  spotEvent?: string;
  displayName?: string;
}

export const NEGOTIATION_SORT_SPOT_EVENT_MAPPING: {
  [key: string]: {
    [key: string]: GASpotEventMappingState;
  };
} = {
  CREW: Object.keys(SORT_TYPE).reduce((acc, cur) => {
    return {
      ...acc,
      [cur]: {
        className: `sort-code__${SORT_TYPE[cur]}`,
        spotEvent: `_ga.spotEvent('[CREW]_クルー','${SCREEN.NEGOTIATION_SEARCH_RESULT.NAME}','${SORT_TYPE_NAME[cur]}')`,
      },
    };
  }, {}),
  AGENCY: Object.keys(SORT_TYPE).reduce((acc, cur) => {
    return {
      ...acc,
      [cur]: {
        className: `sort-code__${SORT_TYPE[cur]}`,
        spotEvent: `_ga.spotEvent('[AGENCY]_代理店','${SCREEN.NEGOTIATION_SEARCH_RESULT.NAME}','${SORT_TYPE_NAME[cur]}')`,
      },
    };
  }, {}),
  EMPLOYEE: Object.keys(SORT_TYPE).reduce((acc, cur) => {
    return {
      ...acc,
      [cur]: {
        className: `sort-code__${SORT_TYPE[cur]}`,
        spotEvent: `_ga.spotEvent('[EMPLOYEE]_営業','${SCREEN.NEGOTIATION_SEARCH_RESULT.NAME}','${SORT_TYPE_NAME[cur]}')`,
      },
    };
  }, {}),
};

export const NEGOTIATION_ACTION_COMMON_MAPPING: { [key: string]: { className: string; displayName: string } } = {
  toSummaryPreview: {
    className: 'toSummaryPreview-action',
    displayName: SCREEN.SUMMARY_PREVIEW.NAME,
  },
};

export const NEGOTIATION_ACTION_CREW_MAPPING: { [key: string]: { className: string; displayName: string } } = {
  ...NEGOTIATION_ACTION_COMMON_MAPPING,
  toNegotiation: {
    className: 'toNegotiation-action',
    displayName: '商談の詳細',
  },
  toCustomer: {
    className: 'toCustomer-action',
    displayName: SCREEN.CUSTOMER_DETAIL.NAME,
  },
  memoNegotiation: {
    className: 'memoNegotiation-action',
    displayName: '商談メモ',
  },
};

export const NEGOTIATION_CUSTOMER_INFO_CREW_MAPPING: { [key: string]: { className: string; screen?: string; displayName: string } } = {
  infoSimulator: {
    className: 'negotiationDetailInfo-simulator',
    screen: '商談詳細',
    displayName: '料金シミュレーション',
  },
  cancelSimulator: {
    className: 'negotiationDetailInfo-cancel-simulator',
    screen: '料金シミュレーション',
    displayName: 'キャンセル',
  },
  moveSimulator: {
    className: 'negotiationDetailInfo-move-simulator',
    screen: '料金シミュレーション',
    displayName: '料金シミュレーターに移動',
  },
  negotiationInfoToSummaryPreview: {
    className: 'negotiationInfo-to-summary-preview',
    screen: 'お客さま情報',
    displayName: 'サマリー',
  },
  overlayButton: {
    className: 'overlayButton',
    screen: 'お客さま情報',
    displayName: 'プラス',
  },
  customerDetailAddBtn: {
    className: 'customerDetail-add',
    screen: 'お客さま情報',
    displayName: '商談追加',
  },
  customerDetailActionAdd: {
    className: 'customerDetail-actionAdd',
    screen: 'お客さま情報',
    displayName: 'アクション追加',
  },
  linkRegisterInfo: {
    className: 'link-register-info',
    screen: 'お客さま情報',
    displayName: '登録連携情報',
  },
  linkRegisterInfoModalClose: {
    className: 'link-register-info-modal-close',
    screen: '登録連携情報',
    displayName: 'バツ',
  },
  customerDetailExternalLinkRegister: {
    className: 'customerDetail-externalLinkRegister',
    screen: 'お客さま情報',
    displayName: 'GINIE/BB-GINIEへの登録連携',
  },
  closeModalRegistrationLinkBtn: {
    className: 'registered-info-external-link-work-type-select-actions--close',
    screen: 'GINIE/BB-GINIEへの登録連携',
    displayName: 'キャンセル',
  },
  nextModalRegistrationLinkBtn: {
    className: 'registered-info-external-link-work-type-select-actions--next',
    screen: 'GINIE/BB-GINIEへの登録連携',
    displayName: '次へ',
  },
  linkRegisterModalClose: {
    className: 'linkRegisterModal-modal',
    screen: 'GINIE/BB-GINIEへの登録連携',
    displayName: 'バツ',
  },
  negotiationAddButton: {
    className: 'negotiation-add-button',
    screen: '商談の追加',
    displayName: 'プラス',
  },
  areaCheckHandler: {
    className: 'area-check-handler',
    screen: 'エリアチェック_事前チェック',
    displayName: 'エリア検索',
  },
  westJpHandler: {
    className: 'west-jp-handler',
    screen: 'エリアチェック_事前チェック',
    displayName: '転用番号（西日本）',
  },
  eastJpHandler: {
    className: 'east-jp-handler',
    screen: 'エリアチェック_事前チェック',
    displayName: '転用番号（東日本）',
  },
  areaCheckClose: {
    className: 'area-check-close',
    screen: 'エリアチェック_事前チェック',
    displayName: 'バツ',
  },

  actionScheduleScheduleToVisitBtnAdd: {
    className: 'actionSchedule-scheduleToVisitBtn',
    screen: 'アクション追加_来店',
    displayName: '来店予約',
  },
  reserveModalScheduleToVisitBtnAdd: {
    className: 'reserveModal-scheduleToVisit',
    screen: 'アクション追加_来店予約',
    displayName: '保存して来店予約に移動',
  },
  scheduleToVisitCancelBtnAdd: {
    className: 'reserveModal-cancel',
    screen: 'アクション追加_来店予約',
    displayName: 'キャンセル',
  },
  actionScheduleScheduleToVisitBtnEdit: {
    className: 'actionSchedule-scheduleToVisitBtn',
    screen: 'アクションの編集_来店',
    displayName: '来店予約',
  },
  reserveModalScheduleToVisitBtnEdit: {
    className: 'reserveModal-scheduleToVisit',
    screen: 'アクションの編集_来店予約',
    displayName: '保存して来店予約に移動',
  },
  scheduleToVisitCancelBtnEdit: {
    className: 'reserveModal-cancel',
    screen: 'アクションの編集_来店予約',
    displayName: 'キャンセル',
  },

  historyTabsPotentialUpdateHistory: {
    className: 'history-tabs-btn-potentialUpdateHistory',
    screen: 'お客さま情報',
    displayName: '履歴_更新履歴タブ',
  },
  historyTabsActionHistory: {
    className: 'history-tabs-btn-actionHistory',
    screen: 'お客さま情報',
    displayName: '履歴_応対履歴タブ',
  },
  openFBCallAddBtn: {
    className: 'open-fb-call',
    screen: 'アクション追加_架電',
    displayName: 'GINIEテレフォニー連携_FBコールを開く',
  },
  openFBCallEditBtn: {
    className: 'open-fb-call',
    screen: 'アクション編集_架電',
    displayName: 'GINIEテレフォニー連携_FBコールを開く',
  },
  addNegotiationIndex: {
    className: 'negotiationIndex',
    screen: '商談の追加',
    displayName: '目次',
  },
  editNegotiationIndex: {
    className: 'negotiationIndex',
    screen: '商談の編集',
    displayName: '目次',
  },
  duplicateProduct: {
    className: 'duplicate-product-available',
    screen: '商談詳細',
    displayName: '商品を複製',
  },
};

export const NEGOTIATION_STATUS_UPDATE_ACTION_CLASSNAME: { [key: string]: string } = {
  CLOSE_BTN: 'negotiation-status-update-actions--close',
  BACK_BTN: 'negotiation-status-update-actions--back',
  EXTERNAL_SYSTEM_BTN: 'negotiation-status-update-actions--external-system',
};

const EXTERNAL_LINK_WORK_MOBILE_COMMON_MAPPING: { [key: string]: { className: string; spotEvent: string } } = {
  closeBtn: {
    className: NEGOTIATION_STATUS_UPDATE_ACTION_CLASSNAME.CLOSE_BTN,
    spotEvent: `_ga.spotEvent('[CREW]_クルー','GINIE/BB-GINIEへの登録連携_モバイル','キャンセル')`,
  },
  backBtn: {
    className: NEGOTIATION_STATUS_UPDATE_ACTION_CLASSNAME.BACK_BTN,
    spotEvent: `_ga.spotEvent('[CREW]_クルー','GINIE/BB-GINIEへの登録連携_モバイル','戻る')`,
  },
};

const EXTERNAL_LINK_WORK_TYPE = {
  /** 新規 */
  MOBILE_NEW: '01',
  /** 各種変更 */
  MOBILE_CHANGE: '02',
  /** YM契約変更/機種変更 */
  MOBILE_YM_CHANGE: '03',
  /** 固定回線登録 */
  INTERNET: '11',
  /** おうちでんき */
  ELECTRICITY: '21',
} as const;

export const NEGOTIATION_STATUS_UPDATE_ACTION_COMMON_MAPPING: {
  [key: string]: { [subKey: string]: { className: string; spotEvent: string } };
} = {
  /** 固定回線登録 */
  [EXTERNAL_LINK_WORK_TYPE.INTERNET]: {
    closeBtn: {
      className: NEGOTIATION_STATUS_UPDATE_ACTION_CLASSNAME.CLOSE_BTN,
      spotEvent: `_ga.spotEvent('[CREW]_クルー','GINIE/BB-GINIEへの登録連携_インターネット','キャンセル')`,
    },
    backBtn: {
      className: NEGOTIATION_STATUS_UPDATE_ACTION_CLASSNAME.BACK_BTN,
      spotEvent: `_ga.spotEvent('[CREW]_クルー','GINIE/BB-GINIEへの登録連携_インターネット','戻る')`,
    },
  },
  /** おうちでんき */
  [EXTERNAL_LINK_WORK_TYPE.ELECTRICITY]: {
    closeBtn: {
      className: NEGOTIATION_STATUS_UPDATE_ACTION_CLASSNAME.CLOSE_BTN,
      spotEvent: `_ga.spotEvent('[CREW]_クルー','GINIE/BB-GINIEへの登録連携_おうちでんき','キャンセル')`,
    },
    backBtn: {
      className: NEGOTIATION_STATUS_UPDATE_ACTION_CLASSNAME.BACK_BTN,
      spotEvent: `_ga.spotEvent('[CREW]_クルー','GINIE/BB-GINIEへの登録連携_おうちでんき','戻る')`,
    },
  },
  /** 新規 */
  [EXTERNAL_LINK_WORK_TYPE.MOBILE_NEW]: EXTERNAL_LINK_WORK_MOBILE_COMMON_MAPPING,
  /** 各種変更 */
  [EXTERNAL_LINK_WORK_TYPE.MOBILE_CHANGE]: EXTERNAL_LINK_WORK_MOBILE_COMMON_MAPPING,
  /** YM契約変更/機種変更 */
  [EXTERNAL_LINK_WORK_TYPE.MOBILE_YM_CHANGE]: EXTERNAL_LINK_WORK_MOBILE_COMMON_MAPPING,
};

const NEGOTIATION_STATUS_UPDATE_EXTERNAL_SYSTEM_STATUS: { [key: string]: string } = {
  EMPTY: 'true',
  NONE_EMPTY: 'false',
};

const EXTERNAL_LINK_WORK_MOBILE_EXTERNAL_SYSTEM_MAPPING: { className: string; spotEvent: { [subKey: string]: string } } = {
  className: NEGOTIATION_STATUS_UPDATE_ACTION_CLASSNAME.EXTERNAL_SYSTEM_BTN,
  spotEvent: {
    [NEGOTIATION_STATUS_UPDATE_EXTERNAL_SYSTEM_STATUS.EMPTY]: `_ga.spotEvent('[CREW]_クルー','GINIE/BB-GINIEへの登録連携_モバイル','GINIEに移動')`,
    [NEGOTIATION_STATUS_UPDATE_EXTERNAL_SYSTEM_STATUS.NONE_EMPTY]: `_ga.spotEvent('[CREW]_クルー','GINIE/BB-GINIEへの登録連携_モバイル','保存してGINIEに移動')`,
  },
};

export const NEGOTIATION_STATUS_UPDATE_EXTERNAL_SYSTEM_MAPPING: {
  [key: string]: { className: string; spotEvent: { [subKey: string]: string } };
} = {
  /** 固定回線登録 */
  [EXTERNAL_LINK_WORK_TYPE.INTERNET]: {
    className: NEGOTIATION_STATUS_UPDATE_ACTION_CLASSNAME.EXTERNAL_SYSTEM_BTN,
    spotEvent: {
      [NEGOTIATION_STATUS_UPDATE_EXTERNAL_SYSTEM_STATUS.EMPTY]: `_ga.spotEvent('[CREW]_クルー','GINIE/BB-GINIEへの登録連携_インターネット','BB-GINIEに移動')`,
      [NEGOTIATION_STATUS_UPDATE_EXTERNAL_SYSTEM_STATUS.NONE_EMPTY]: `_ga.spotEvent('[CREW]_クルー','GINIE/BB-GINIEへの登録連携_インターネット','保存して次へ')`,
    },
  },
  /** おうちでんき */
  [EXTERNAL_LINK_WORK_TYPE.ELECTRICITY]: {
    className: NEGOTIATION_STATUS_UPDATE_ACTION_CLASSNAME.EXTERNAL_SYSTEM_BTN,
    spotEvent: {
      [NEGOTIATION_STATUS_UPDATE_EXTERNAL_SYSTEM_STATUS.EMPTY]: `_ga.spotEvent('[CREW]_クルー','GINIE/BB-GINIEへの登録連携_おうちでんき','GINIEに移動')`,
      [NEGOTIATION_STATUS_UPDATE_EXTERNAL_SYSTEM_STATUS.NONE_EMPTY]: `_ga.spotEvent('[CREW]_クルー','GINIE/BB-GINIEへの登録連携_おうちでんき','保存してGINIEに移動')`,
    },
  },
  /** 新規 */
  [EXTERNAL_LINK_WORK_TYPE.MOBILE_NEW]: EXTERNAL_LINK_WORK_MOBILE_EXTERNAL_SYSTEM_MAPPING,
  /** 各種変更 */
  [EXTERNAL_LINK_WORK_TYPE.MOBILE_CHANGE]: EXTERNAL_LINK_WORK_MOBILE_EXTERNAL_SYSTEM_MAPPING,
  /** YM契約変更/機種変更 */
  [EXTERNAL_LINK_WORK_TYPE.MOBILE_YM_CHANGE]: EXTERNAL_LINK_WORK_MOBILE_EXTERNAL_SYSTEM_MAPPING,
};

export const REPORT_SWITCH_TAB_CLASSNAME: { [key: string]: string } = {
  countTableDispNegotiation: 'countTable-dispNegotiation',
  countTableDispCustomer: 'countTable-dispCustomer',
};

export const NEGOTIATION_REPORT_COMMON: {
  [key: string]: {
    [key: string]: { className: string; displayName: string; screen: string } | { [subKey: string]: { displayName: string } };
  };
} = {
  // レポート > 商談中 > 対応期間別
  underNegotiationPeriod: {
    countTableDispNegotiation: {
      className: REPORT_SWITCH_TAB_CLASSNAME.countTableDispNegotiation,
      screen: 'レポート商談中',
      displayName: '対応期間別の合計_表示の切り替え_商談数',
    },
    countTableDispCustomer: {
      className: REPORT_SWITCH_TAB_CLASSNAME.countTableDispCustomer,
      screen: 'レポート商談中',
      displayName: '対応期間別の合計_表示の切り替え_顧客数',
    },
    // 対応期間別の合計
    [REPORT_SECTIONS_COMMON.CARD.key]: {
      today: {
        displayName: '対応期間別の合計_当日',
      },
      tomorrow: {
        displayName: '対応期間別の合計_翌日',
      },
      week: {
        displayName: '対応期間別の合計_当週',
      },
      month: {
        displayName: '対応期間別の合計_当月',
      },
      overdue: {
        displayName: '対応期間別の合計_期日超過',
      },
      nextmonth: {
        displayName: '対応期間別の合計_翌月',
      },
      unset: {
        displayName: '対応期間別の合計_未入力',
      },
    },
    // すべてのデータ（商談数で表示されます）
    [REPORT_SECTIONS_COMMON.TABLE.key]: {
      today: {
        displayName: '対応期間別_すべてのデータ_当日',
      },
    },
  },
  // レポート > 商談中 > 次のアクション
  underNegotiationAction: {
    countTableDispNegotiation: {
      className: REPORT_SWITCH_TAB_CLASSNAME.countTableDispNegotiation,
      screen: 'レポート商談中',
      displayName: '次のアクション_表示の切り替え_商談数',
    },
    countTableDispCustomer: {
      className: REPORT_SWITCH_TAB_CLASSNAME.countTableDispCustomer,
      screen: 'レポート商談中',
      displayName: '次のアクション_表示の切り替え_顧客数',
    },
    // 次のアクションの合計
    [REPORT_SECTIONS_COMMON.CARD.key]: {
      '01': {
        displayName: '次のアクション_来店予定',
      },
      '02': {
        displayName: '次のアクション_架電予定',
      },
      '03': {
        displayName: '次のアクション_入電待ち',
      },
      '00': {
        displayName: '次のアクション_未入力',
      },
      total: {
        displayName: '次のアクション_合計',
      },
    },
  },
  // レポート > 商談中 > 契約確率
  underNegotiationProd: {
    countTableDispNegotiation: {
      className: REPORT_SWITCH_TAB_CLASSNAME.countTableDispNegotiation,
      screen: 'レポート商談中',
      displayName: '契約確率_表示の切り替え_商談数',
    },
    countTableDispCustomer: {
      className: REPORT_SWITCH_TAB_CLASSNAME.countTableDispCustomer,
      screen: 'レポート商談中',
      displayName: '契約確率_表示の切り替え_顧客数',
    },
    // 契約確率の合計
    [REPORT_SECTIONS_COMMON.CARD.key]: {
      '01': {
        displayName: '契約確率_A',
      },
      '02': {
        displayName: '契約確率_B',
      },
      '03': {
        displayName: '契約確率_C',
      },
      '04': {
        displayName: '契約確率_D',
      },
      '05': {
        displayName: '契約確率_E',
      },
      '00': {
        displayName: '契約確率_未入力',
      },
      total: {
        displayName: '契約確率_合計',
      },
    },
  },
  // レポート > 長期保留 > 保留期間別
  pendingNegotiation: {
    countTableDispNegotiation: {
      className: REPORT_SWITCH_TAB_CLASSNAME.countTableDispNegotiation,
      screen: 'レポート長期保留',
      displayName: '保留期間別_商談数',
    },
    countTableDispCustomer: {
      className: REPORT_SWITCH_TAB_CLASSNAME.countTableDispCustomer,
      screen: 'レポート長期保留',
      displayName: '保留期間別_顧客数',
    },
    // 保留期間別の合計
    [REPORT_SECTIONS_COMMON.CARD.key]: {
      '3rdMonth': {
        displayName: '保留期間別_2ヶ月後',
      },
      '4thMonth': {
        displayName: '保留期間別_3ヶ月後',
      },
      '5thMonth': {
        displayName: '保留期間別_4ヶ月後',
      },
      restoration: {
        displayName: '保留期間別_復活予定',
      },
      total: {
        displayName: '保留期間別_合計',
      },
    },
  },
  // レポート > 長期保留 > 次のアクション
  pendingNegotiationAction: {
    // 次のアクションの合計
    [REPORT_SECTIONS_COMMON.CARD.key]: {
      '01': {
        displayName: '次のアクション_来店予定',
      },
      '02': {
        displayName: '次のアクション_架電予定',
      },
    },
  },
};

export const COMMON_FILTER_STORE_MAPPING: { [key: string]: { className: string; screen?: string; displayName: string } } = {
  close: {
    className: 'event_drawer_store_close',
    displayName: 'バツ',
  },
  cancel: {
    className: 'event_drawer_store_cancel',
    displayName: 'キャンセル',
  },
  addStore: {
    className: 'event_drawer_store_add',
    displayName: '店舗を追加',
  },
  resetToOwnStore: {
    className: 'event_drawer_store_reset',
    displayName: 'リセット（自店舗のみに戻す）',
  },
};
// ダッシュボード_表示店舗GAイベントマッピング定数
export const DASHBOARD_STORE_FILTER_MAPPING: { [key: string]: { className: string; screen?: string; displayName: string } } = {
  openEditModal: {
    className: 'dashaboard_store_open_edit_modal',
    screen: 'ダッシュボード_表示店舗',
    displayName: '店舗フィルタを編集',
  },
  storeFilter: {
    className: 'dashaboard_store_open_edit_modal',
    screen: 'ダッシュボード_表示店舗',
    displayName: '店舗フィルタ',
  },
  add: {
    className: 'dashaboard_store_add',
    screen: 'ダッシュボード_表示店舗',
    displayName: '追加',
  },
  closeDashboard: {
    className: 'dashaboard_store_close',
    screen: 'ダッシュボード_表示店舗',
    displayName: 'バツ',
  },
  cancelDashboard: {
    className: 'dashaboard_store_cancel',
    screen: 'ダッシュボード_表示店舗',
    displayName: 'キャンセル',
  },
};

export const STORE_FILTER_MANAGEMENT_MAPPING: { [key: string]: { className: string; screen?: string; displayName: string } } = {
  close: {
    className: 'store_filter_management_close',
    screen: '店舗フィルタ',
    displayName: 'バツ',
  },
  cancel: {
    className: 'store_filter_management_cancel',
    screen: '店舗フィルタ',
    displayName: 'キャンセル',
  },
  save: {
    className: 'store_filter_management_save',
    screen: '店舗フィルタ',
    displayName: 'フィルタを保存',
  },
  delete: {
    className: 'store_filter_management_delete',
    screen: '店舗フィルタ',
    displayName: 'このフィルタを削除',
  },
  create: {
    className: 'store_filter_management_create',
    screen: '店舗フィルタ',
    displayName: '新規フィルタ',
  },
  ...DASHBOARD_STORE_FILTER_MAPPING,
};

export const STORE_FILTER_SPOT_EVENT_MAPPING: {
  [key: string]: {
    [key: string]: GASpotEventMappingState;
  };
} = {
  AGENCY: Object.keys(STORE_FILTER_MANAGEMENT_MAPPING).reduce((acc, cur) => {
    const { className, displayName, screen } = STORE_FILTER_MANAGEMENT_MAPPING[cur];
    return {
      ...acc,
      [cur]: {
        className,
        spotEvent: `_ga.spotEvent('${GA_EVENT_CATEGORY.AGENCY}','${screen}','${displayName}')`,
      },
    };
  }, {}),
  EMPLOYEE: Object.keys(STORE_FILTER_MANAGEMENT_MAPPING).reduce((acc, cur) => {
    const { className, displayName, screen } = STORE_FILTER_MANAGEMENT_MAPPING[cur];
    return {
      ...acc,
      [cur]: {
        className,
        spotEvent: `_ga.spotEvent('${GA_EVENT_CATEGORY.EMPLOYEE}','${screen}','${displayName}')`,
      },
    };
  }, {}),
};

export const COMMON_MODAL_STORE_MAPPING: { [key: string]: { className: string; screen?: string; displayName: string } } = {
  close: {
    className: 'event_modal_store_close',
    displayName: 'バツ',
  },
  cancel: {
    className: 'event_modal_store_cancel',
    displayName: 'キャンセル',
  },
  add: {
    className: 'event_modal_store_add',
    displayName: '追加',
  },
};

export const FILTER_STORE_SPOT_EVENT_MAPPING: {
  [key: string]: {
    [key: string]: {
      [key: string]: GASpotEventState;
    };
  };
} = {
  CREW: Object.keys(FILTER_NEW_SCREEN_KEY).reduce((acc, cur) => {
    return {
      ...acc,
      [cur]: Object.keys(COMMON_FILTER_STORE_MAPPING).reduce((subAcc, subCur) => {
        const { className, displayName } = COMMON_FILTER_STORE_MAPPING[subCur];
        const screen = `${SCREEN_NAME_COMMON[cur]}${FILTER_NEW_DRAWER_SCREEN_NAME_ADD[cur]}`;
        return {
          ...subAcc,
          [subCur]: {
            className,
            spotEvent: `_ga.spotEvent('[CREW]_クルー','${screen}','${displayName}')`,
          },
        };
      }, {}),
    };
  }, {}),
  AGENCY: Object.keys(FILTER_NEW_SCREEN_KEY).reduce((acc, cur) => {
    return {
      ...acc,
      [cur]: Object.keys(COMMON_FILTER_STORE_MAPPING).reduce((subAcc, subCur) => {
        const { className, displayName } = COMMON_FILTER_STORE_MAPPING[subCur];
        const screen = `${SCREEN_NAME_COMMON[cur]}${FILTER_NEW_DRAWER_SCREEN_NAME_ADD[cur]}`;
        return {
          ...subAcc,
          [subCur]: {
            className,
            spotEvent: `_ga.spotEvent('${GA_EVENT_CATEGORY.AGENCY}','${screen}','${displayName}')`,
          },
        };
      }, {}),
    };
  }, {}),
  EMPLOYEE: Object.keys(FILTER_NEW_SCREEN_KEY).reduce((acc, cur) => {
    return {
      ...acc,
      [cur]: Object.keys(COMMON_FILTER_STORE_MAPPING).reduce((subAcc, subCur) => {
        const { className, displayName } = COMMON_FILTER_STORE_MAPPING[subCur];
        const screen = `${SCREEN_NAME_COMMON[cur]}${FILTER_NEW_DRAWER_SCREEN_NAME_ADD[cur]}`;
        return {
          ...subAcc,
          [subCur]: {
            className,
            spotEvent: `_ga.spotEvent('${GA_EVENT_CATEGORY.EMPLOYEE}','${screen}','${displayName}')`,
          },
        };
      }, {}),
    };
  }, {}),
};

export const MODAL_STORE_SPOT_EVENT_MAPPING: {
  [key: string]: {
    [key: string]: {
      [key: string]: GASpotEventState;
    };
  };
} = {
  CREW: Object.keys(FILTER_NEW_SCREEN_KEY).reduce((acc, cur) => {
    return {
      ...acc,
      [cur]: Object.keys(COMMON_MODAL_STORE_MAPPING).reduce((subAcc, subCur) => {
        const { className, displayName } = COMMON_MODAL_STORE_MAPPING[subCur];
        const screen = `${SCREEN_NAME_COMMON[cur]}${FILTER_NEW_MODAL_SCREEN_NAME_ADD[cur]}`;
        return {
          ...subAcc,
          [subCur]: {
            className,
            spotEvent: `_ga.spotEvent('[CREW]_クルー','${screen}','${displayName}')`,
          },
        };
      }, {}),
    };
  }, {}),
  AGENCY: Object.keys(FILTER_NEW_SCREEN_KEY).reduce((acc, cur) => {
    return {
      ...acc,
      [cur]: Object.keys(COMMON_MODAL_STORE_MAPPING).reduce((subAcc, subCur) => {
        const { className, displayName } = COMMON_MODAL_STORE_MAPPING[subCur];
        const screen = `${SCREEN_NAME_COMMON[cur]}${FILTER_NEW_MODAL_SCREEN_NAME_ADD[cur]}`;
        return {
          ...subAcc,
          [subCur]: {
            className,
            spotEvent: `_ga.spotEvent('${GA_EVENT_CATEGORY.AGENCY}','${screen}','${displayName}')`,
          },
        };
      }, {}),
    };
  }, {}),
  EMPLOYEE: Object.keys(FILTER_NEW_SCREEN_KEY).reduce((acc, cur) => {
    return {
      ...acc,
      [cur]: Object.keys(COMMON_MODAL_STORE_MAPPING).reduce((subAcc, subCur) => {
        const { className, displayName } = COMMON_MODAL_STORE_MAPPING[subCur];
        const screen = `${SCREEN_NAME_COMMON[cur]}${FILTER_NEW_MODAL_SCREEN_NAME_ADD[cur]}`;
        return {
          ...subAcc,
          [subCur]: {
            className,
            spotEvent: `_ga.spotEvent('${GA_EVENT_CATEGORY.EMPLOYEE}','${screen}','${displayName}')`,
          },
        };
      }, {}),
    };
  }, {}),
};

export const REPORT_OPEN_FILTER_MAPPING: {
  [key: string]: {
    [key: string]: {
      [key: string]: GASpotEventState;
    };
  };
} = {
  CREW: {
    [FILTER_NEW_SCREEN_KEY.underNegotiation]: Object.keys(FILTER_MAPPING).reduce((acc, cur) => {
      const { id, displayName } = FILTER_MAPPING[cur];
      const screen = SCREEN_NAME_COMMON.underNegotiation;
      return {
        ...acc,
        [cur]: {
          id,
          spotEvent: `_ga.spotEvent('[CREW]_クルー','${screen}','${displayName}')`,
        },
      };
    }, {}),
  },
  AGENCY: {
    [FILTER_NEW_SCREEN_KEY.underNegotiation]: Object.keys(FILTER_MAPPING).reduce((acc, cur) => {
      const { id, displayName } = FILTER_MAPPING[cur];
      const screen = SCREEN_NAME_COMMON.underNegotiation;
      return {
        ...acc,
        [cur]: {
          id,
          spotEvent: `_ga.spotEvent('${GA_EVENT_CATEGORY.AGENCY}','${screen}','${displayName}')`,
        },
      };
    }, {}),
  },
  EMPLOYEE: {
    [FILTER_NEW_SCREEN_KEY.underNegotiation]: Object.keys(FILTER_MAPPING).reduce((acc, cur) => {
      const { id, displayName } = FILTER_MAPPING[cur];
      const screen = SCREEN_NAME_COMMON.underNegotiation;
      return {
        ...acc,
        [cur]: {
          id,
          spotEvent: `_ga.spotEvent(','${screen}','${displayName}')`,
        },
      };
    }, {}),
  },
};

// リフレッシュボタンのGAイベント用の定数
export const REFRESH_SPOT_EVENT_MAPPING: {
  [key: string]: {
    [key: string]: GASpotEventState;
  };
} = {
  CREW: Object.keys(SCREEN_REFRESH_KEY_COMMON).reduce((acc, cur) => {
    return {
      ...acc,
      [cur]: {
        className: REFRESH_BTN_COMMON.CLASSNAME,
        spotEvent: `_ga.spotEvent('[CREW]_クルー','${SCREEN_NAME_COMMON[cur]}','${REFRESH_BTN_COMMON.LABEL}')`,
      },
    };
  }, {}),
  AGENCY: Object.keys(VIST_SUMMARY_REFRESH_KEY).reduce((acc, cur) => {
    return {
      ...acc,
      [cur]: {
        className: REFRESH_BTN_COMMON.CLASSNAME,
        spotEvent: `_ga.spotEvent('[AGENCY]_代理店','${SCREEN_NAME_COMMON[cur]}','${REFRESH_BTN_COMMON.LABEL}')`,
      },
    };
  }, {}),
  EMPLOYEE: Object.keys(VIST_SUMMARY_REFRESH_KEY).reduce((acc, cur) => {
    return {
      ...acc,
      [cur]: {
        className: REFRESH_BTN_COMMON.CLASSNAME,
        spotEvent: `_ga.spotEvent('[EMPLOYEE]_営業','${SCREEN_NAME_COMMON[cur]}','${REFRESH_BTN_COMMON.LABEL}')`,
      },
    };
  }, {}),
};

export const NEGOTIATION_REPORTS_PAGE_COMMON_MAPPING: {
  [key: string]: {
    [key: string]: {
      [key: string]: {
        [key: string]: GASpotEventState;
      };
    };
  };
} = {
  CREW: {
    [FILTER_NEW_SCREEN_KEY.underNegotiation]: {
      [FILTER_SECTIONS_KEY.BUTTON]: REPORT_OPEN_FILTER_MAPPING['CREW'][FILTER_NEW_SCREEN_KEY.underNegotiation],
      [FILTER_SECTIONS_KEY.DRAWER]: FILTER_STORE_SPOT_EVENT_MAPPING['CREW'][FILTER_NEW_SCREEN_KEY.underNegotiation],
      [FILTER_SECTIONS_KEY.MODAL]: MODAL_STORE_SPOT_EVENT_MAPPING['CREW'][FILTER_NEW_SCREEN_KEY.underNegotiation],
      [REFRESH_BTN_COMMON.KEY]: {
        [REFRESH_BTN_COMMON.KEY]: REFRESH_SPOT_EVENT_MAPPING['CREW'][SCREEN_REFRESH_KEY_COMMON.underNegotiation],
      },
    },
    [PENDING_NEGOTIATION_TAB_KEY.pendingNegotiation]: {
      [REFRESH_BTN_COMMON.KEY]: {
        [REFRESH_BTN_COMMON.KEY]: REFRESH_SPOT_EVENT_MAPPING['CREW'][SCREEN_REFRESH_KEY_COMMON.pendingNegotiation],
      },
    },
  },
  AGENCY: {
    [FILTER_NEW_SCREEN_KEY.underNegotiation]: {
      [FILTER_SECTIONS_KEY.BUTTON]: REPORT_OPEN_FILTER_MAPPING['AGENCY'][FILTER_NEW_SCREEN_KEY.underNegotiation],
      [FILTER_SECTIONS_KEY.DRAWER]: FILTER_STORE_SPOT_EVENT_MAPPING['AGENCY'][FILTER_NEW_SCREEN_KEY.underNegotiation],
      [FILTER_SECTIONS_KEY.MODAL]: MODAL_STORE_SPOT_EVENT_MAPPING['AGENCY'][FILTER_NEW_SCREEN_KEY.underNegotiation],
      [REFRESH_BTN_COMMON.KEY]: {
        [REFRESH_BTN_COMMON.KEY]: REFRESH_SPOT_EVENT_MAPPING['AGENCY'][SCREEN_REFRESH_KEY_COMMON.underNegotiation],
      },
    },
    [PENDING_NEGOTIATION_TAB_KEY.pendingNegotiation]: {
      [REFRESH_BTN_COMMON.KEY]: {
        [REFRESH_BTN_COMMON.KEY]: REFRESH_SPOT_EVENT_MAPPING['AGENCY'][SCREEN_REFRESH_KEY_COMMON.pendingNegotiation],
      },
    },
  },
};

export const NEGOTIATION_REPORT_COMMON_MAPPING: {
  [key: string]: {
    [key: string]: {
      [key: string]: GASpotEventMappingState | { [subKey: string]: GASpotEventMappingState };
    };
  };
} = {
  CREW: Object.keys(NEGOTIATION_REPORT_COMMON).reduce((acc, cur) => {
    return {
      ...acc,
      [cur]: Object.keys(NEGOTIATION_REPORT_COMMON[cur]).reduce((subAcc, subCur) => {
        const currentValues = Object.values(NEGOTIATION_REPORT_COMMON[cur][subCur]);
        if (REPORT_SECTIONS_COMMON.CARD.key === subCur) {
          return {
            ...subAcc,
            [subCur]: Object.keys(NEGOTIATION_REPORT_COMMON[cur][subCur]).reduce((subSubAcc, subSubCur, index) => {
              const customClassName = `${REPORT_SECTIONS_COMMON[subCur].className}__${cur}-${index}`;
              return {
                ...subSubAcc,
                [subSubCur]: {
                  className: customClassName,
                  spotEvent: `_ga.spotEvent('[CREW]_クルー','${REPORT_SCREEN_NAME_COMMON[cur]}','${currentValues[index].displayName}')`,
                },
              };
            }, {}),
          };
        }
        if (REPORT_SECTIONS_COMMON.TABLE.key === subCur) {
          return {
            ...subAcc,
            [subCur]: Object.keys(NEGOTIATION_REPORT_COMMON[cur][subCur]).reduce((subSubAcc, subSubCur, index) => {
              return {
                ...subSubAcc,
                ...Object.keys(REPORT_ROW_TABLE_COMMON_MAPPING).reduce((tableColumnMapping, columnKey, subIndex) => {
                  const customDisplayName = `${currentValues[index].displayName}_${REPORT_ROW_TABLE_COMMON_MAPPING[columnKey].displayName}`;
                  const customClassName = `${REPORT_SECTIONS_COMMON[subCur].className}__${cur}-${index}-${subIndex}`;
                  const customKeyMapping = `${subSubCur}_${columnKey}`;
                  return {
                    ...tableColumnMapping,
                    [customKeyMapping]: {
                      className: customClassName,
                      spotEvent: `_ga.spotEvent('[CREW]_クルー','${REPORT_SCREEN_NAME_COMMON[cur]}','${customDisplayName}')`,
                    },
                  };
                }, {}),
              };
            }, {}),
          };
        }
        const { className, screen, displayName } = NEGOTIATION_REPORT_COMMON[cur][subCur];
        return {
          ...subAcc,
          [subCur]: {
            className,
            spotEvent: `_ga.spotEvent('[CREW]_クルー','${screen}','${displayName}')`,
          },
        };
      }, {}),
    };
  }, {}),
  AGENCY: Object.keys(NEGOTIATION_REPORT_COMMON).reduce((acc, cur) => {
    return {
      ...acc,
      [cur]: Object.keys(NEGOTIATION_REPORT_COMMON[cur]).reduce((subAcc, subCur) => {
        if ([REPORT_SECTIONS_COMMON.CARD.key, REPORT_SECTIONS_COMMON.TABLE.key].includes(subCur)) return subAcc;
        const { className, screen, displayName } = NEGOTIATION_REPORT_COMMON[cur][subCur];
        return {
          ...subAcc,
          [subCur]: {
            className,
            spotEvent: `_ga.spotEvent('[AGENCY]_代理店','${screen}','${displayName}')`,
          },
        };
      }, {}),
    };
  }, {}),
  EMPLOYEE: Object.keys(NEGOTIATION_REPORT_COMMON).reduce((acc, cur) => {
    return {
      ...acc,
      [cur]: Object.keys(NEGOTIATION_REPORT_COMMON[cur]).reduce((subAcc, subCur) => {
        if ([REPORT_SECTIONS_COMMON.CARD.key, REPORT_SECTIONS_COMMON.TABLE.key].includes(subCur)) return subAcc;
        const { className, screen, displayName } = NEGOTIATION_REPORT_COMMON[cur][subCur];
        return {
          ...subAcc,
          [subCur]: {
            className,
            spotEvent: `_ga.spotEvent('[EMPLOYEE]_営業','${screen}','${displayName}')`,
          },
        };
      }, {}),
    };
  }, {}),
};

export const NEGOTIATION_DETAIL_SPOT_EVENT_MAPPING: {
  [key: string]: {
    [key: string]: GASpotEventMappingState;
  };
} = {
  CREW: Object.keys(NEGOTIATION_CUSTOMER_INFO_CREW_MAPPING).reduce((acc, cur) => {
    const { className, displayName, screen } = NEGOTIATION_CUSTOMER_INFO_CREW_MAPPING[cur];
    return {
      ...acc,
      [cur]: {
        className,
        spotEvent: `_ga.spotEvent('[CREW]_クルー','${screen}','${displayName}')`,
      },
    };
  }, {}),
};

export const NEGOTIATION_ACTION_SPOT_EVENT_MAPPING: {
  [key: string]: {
    [key: string]: GASpotEventMappingState;
  };
} = {
  CREW: Object.keys(NEGOTIATION_ACTION_CREW_MAPPING).reduce((acc, cur) => {
    const { className, displayName } = NEGOTIATION_ACTION_CREW_MAPPING[cur];
    return {
      ...acc,
      [cur]: {
        className,
        spotEvent: `_ga.spotEvent('[CREW]_クルー','${SCREEN.NEGOTIATION_SEARCH_RESULT.NAME}','${displayName}')`,
      },
    };
  }, {}),
  AGENCY: Object.keys(NEGOTIATION_ACTION_COMMON_MAPPING).reduce((acc, cur) => {
    const { className, displayName } = NEGOTIATION_ACTION_COMMON_MAPPING[cur];
    return {
      ...acc,
      [cur]: {
        className,
        spotEvent: `_ga.spotEvent('[AGENCY]_代理店','${SCREEN.NEGOTIATION_SEARCH_RESULT.NAME}','${displayName}')`,
      },
    };
  }, {}),
  EMPLOYEE: Object.keys(NEGOTIATION_ACTION_COMMON_MAPPING).reduce((acc, cur) => {
    const { className, displayName } = NEGOTIATION_ACTION_COMMON_MAPPING[cur];
    return {
      ...acc,
      [cur]: {
        className,
        spotEvent: `_ga.spotEvent('[EMPLOYEE]_営業','${SCREEN.NEGOTIATION_SEARCH_RESULT.NAME}','${displayName}')`,
      },
    };
  }, {}),
};

// 商談メモドロワーGAイベント用の画面名定数
export const NEGOTIATION_MEMO_DRAWER_SCREEN = {
  productCreate: '商品の追加',
  productEdit: '商品の編集',
  actionCreateVisit: 'アクションの追加_来店',
  actionCreateCall: 'アクションの追加_架電',
  actionCreateWaiting: 'アクションの追加_受電待ち',
  actionEditVisit: 'アクションの編集_来店',
  actionEditCall: 'アクションの編集_架電',
  actionEditWaiting: 'アクションの編集_受電待ち',
} as const;

export type NegotiationMemoDrawerScreenName = keyof typeof NEGOTIATION_MEMO_DRAWER_SCREEN;

export const NEGOTIATION_MEMO_DRAWER_ACTION_SCREEN: {
  [actionType: string]: { create: NegotiationMemoDrawerScreenName; edit: NegotiationMemoDrawerScreenName };
} = {
  [ACTION_TYPE.SCHEDULED_TO_VISIT]: { create: 'actionCreateVisit', edit: 'actionEditVisit' },
  [ACTION_TYPE.CALL_SCHEDULE]: { create: 'actionCreateCall', edit: 'actionEditCall' },
  [ACTION_TYPE.WAITING_FOR_INCOMING_CALL]: { create: 'actionCreateWaiting', edit: 'actionEditWaiting' },
};

type NegotiationMemoDrawerButtonKey = 'memoButton' | 'close';

const NEGOTIATION_MEMO_DRAWER_BUTTONS: { [key in NegotiationMemoDrawerButtonKey]: { classPrefix: string; displayName: string } } = {
  memoButton: { classPrefix: 'negotiation-memo-drawer__btn', displayName: '商談メモ' },
  close: { classPrefix: 'negotiation-memo-drawer__close', displayName: 'バツ' },
};

// 商談メモドロワーGAイベントマッピング定数
type NegotiationMemoDrawerSpotEventMapping = {
  [key in NegotiationMemoDrawerButtonKey]: {
    [subKey in NegotiationMemoDrawerScreenName]: GASpotEventState;
  };
};

const buildNegotiationMemoScreenMapping = ({ classPrefix, displayName }: { classPrefix: string; displayName: string }) =>
  (Object.keys(NEGOTIATION_MEMO_DRAWER_SCREEN) as NegotiationMemoDrawerScreenName[]).reduce(
    (acc, screenKey) => ({
      ...acc,
      [screenKey]: {
        className: `${classPrefix}--${screenKey}`,
        spotEvent: `_ga.spotEvent('${GA_EVENT_CATEGORY.CREW}','${NEGOTIATION_MEMO_DRAWER_SCREEN[screenKey]}','${displayName}')`,
      },
    }),
    {} as { [subKey in NegotiationMemoDrawerScreenName]: GASpotEventState },
  );

export const NEGOTIATION_MEMO_DRAWER_SPOT_EVENT_MAPPING: NegotiationMemoDrawerSpotEventMapping = {
  memoButton: buildNegotiationMemoScreenMapping(NEGOTIATION_MEMO_DRAWER_BUTTONS.memoButton),
  close: buildNegotiationMemoScreenMapping(NEGOTIATION_MEMO_DRAWER_BUTTONS.close),
};

export const SIDE_NAV_SPOT_EVENT_MAPPING: {
  [key: string]: {
    [key: string]: GASpotEventMappingState;
  };
} = {
  CREW: Object.keys(SIDE_NAV_CREW_MAPPING).reduce((acc, cur) => {
    const { className, displayName } = SIDE_NAV_CREW_MAPPING[cur];
    return {
      ...acc,
      [cur]: {
        className,
        spotEvent: `_ga.spotEvent('[CREW]_クルー','サイドメニュー','${displayName}')`,
      },
    };
  }, {}),
  AGENCY: Object.keys(SIDE_NAV_COMMON_MAPPING).reduce((acc, cur) => {
    const { className, displayName } = SIDE_NAV_COMMON_MAPPING[cur];
    return {
      ...acc,
      [cur]: {
        className,
        spotEvent: `_ga.spotEvent('[AGENCY]_代理店','サイドメニュー','${displayName}')`,
      },
    };
  }, {}),
  EMPLOYEE: Object.keys(SIDE_NAV_COMMON_MAPPING).reduce((acc, cur) => {
    const { className, displayName } = SIDE_NAV_COMMON_MAPPING[cur];
    return {
      ...acc,
      [cur]: {
        className,
        spotEvent: `_ga.spotEvent('[EMPLOYEE]_営業','サイドメニュー','${displayName}')`,
      },
    };
  }, {}),
};

/** -------------------------------------------------
 * PCM-I-4211-6 TDタグ対応（8月分）
 * --------------------------------------------------*/
export const FILTER_DRAWER_NEGOTIATION_LABEL_COMMON_MAPPING: {
  [key: string]: string;
} = {
  execute: '絞り込み',
};

export const ADD_CONDITION_BUTTON_LABEL_COMMON_MAPPING: {
  [key: string]: string;
} = {
  cancel: 'キャンセル',
  close: 'バツ',
  add: '追加',
};

export const ADD_CONDITION_SCREENS_MAPPING: {
  [key: string]: string;
} = {
  address: '宛先選択_条件を追加',
};

export const MAIL_CREATE_MODAL_COMMON_MAPPING: {
  [key: string]: string;
} = {
  one: '個別送信',
  multi: '一斉送信',
};

export const MAIL_CREATE_SCREENS_MAPPING: {
  [key: string]: string;
} = {
  mailTop: '送信方法の選択',
};

export const ADD_CONDITION_NEGOTIATION_LABEL_COMMON_MAPPING: {
  [key: string]: string;
} = {
  add: '追加',
};

export const DRAWER_FULL_LABEL_COMMON_MAPPING: {
  [key: string]: string;
} = {
  close: 'バツ',
  clear: 'クリア',
  execute: '絞り込み',
  addCondition: '条件を追加',
};

export const FILTER_MAIL_SCREENS_MAPPING: {
  [key: string]: string;
} = {
  top: 'メール_絞り込み',
  template: 'テンプレート管理_絞り込み',
  address: '宛先選択_絞り込み',
};

export const MAIL_TOP_LABEL_COMMON_MAPPING: {
  [key: string]: string;
} = {
  create: 'メール作成',
  [REFRESH_BTN_COMMON.KEY]: 'リフレッシュ',
  edit: '内容編集',
  view: '内容参照',
  filter: '絞り込み',
  toTemplate: 'テンプレート管理',
};

export const MAIL_TEMPLATE_LABEL_COMMON_MAPPING: {
  [key: string]: string;
} = {
  create: '新規テンプレート作成',
  [REFRESH_BTN_COMMON.KEY]: 'リフレッシュ',
  view: '詳細',
  filter: '絞り込み',
};

export const MAIL_ADDRESS_LABEL_COMMON_MAPPING: {
  [key: string]: string;
} = {
  back: 'もどる',
  [REFRESH_BTN_COMMON.KEY]: 'リフレッシュ',
  view: 'お客さま詳細',
  filter: '絞り込み',
  toMailSend: '送信内容確認',
};

export const MAIL_SEND_LABEL_COMMON_MAPPING: {
  [key: string]: string;
} = {
  edit: '内容を修正',
  saveDraft: '下書き保存',
  send: '送信',
  view: '詳細',
  back: '宛先選択へもどる',
};

export const MAIL_SEND_MODAL_SPOT_EVENT_MAPPING: {
  [key: string]: GASpotEventState;
} = {
  ...Object.keys(MAIL_SEND_LABEL_COMMON_MAPPING).reduce((acc, cur) => {
    const displayName = MAIL_SEND_LABEL_COMMON_MAPPING[cur];
    const className = `mail-send__${cur}`;
    return {
      ...acc,
      [cur]: {
        className,
        spotEvent: `_ga.spotEvent('[CREW]_クルー','宛先選択_送信内容確認','${displayName}')`,
      },
    };
  }, {}),
};

export const MAIL_TEMPLATE_CONFIRM_LABEL_COMMON_MAPPING: {
  [key: string]: string;
} = {
  edit: '入力内容確認_内容を修正',
  saveDraft: '入力内容確認_下書き保存',
  apply: '入力内容確認_テンプレートを申請',
  back: '入力内容確認_新規テンプレート作成へもどる',
};

export const MAIL_TEMPLATE_CONFIRM_MODAL_SPOT_EVENT_MAPPING: {
  [key: string]: GASpotEventState;
} = {
  ...Object.keys(MAIL_TEMPLATE_CONFIRM_LABEL_COMMON_MAPPING).reduce((acc, cur) => {
    const displayName = MAIL_TEMPLATE_CONFIRM_LABEL_COMMON_MAPPING[cur];
    const className = `mail-template-confirm__${cur}`;
    return {
      ...acc,
      [cur]: {
        className,
        spotEvent: `_ga.spotEvent('[CREW]_クルー','新規テンプレート作成','${displayName}')`,
      },
    };
  }, {}),
};

export const MAIL_TEMPLATE_APPLY_LABEL_COMMON_MAPPING: {
  [key: string]: string;
} = {
  cancel: 'キャンセル',
  insert: 'パラメーター_挿入',
  saveDraft: '下書き保存',
  confirm: '入力内容確認',
  back: 'テンプレート管理へもどる',
};

export const MAIL_TEMPLATE_APPLY_MODAL_SPOT_EVENT_MAPPING: {
  [key: string]: GASpotEventState;
} = {
  ...Object.keys(MAIL_TEMPLATE_APPLY_LABEL_COMMON_MAPPING).reduce((acc, cur) => {
    const displayName = MAIL_TEMPLATE_APPLY_LABEL_COMMON_MAPPING[cur];
    const className = `mail-template-apply__${cur}`;
    return {
      ...acc,
      [cur]: {
        className,
        spotEvent: `_ga.spotEvent('[CREW]_クルー','新規テンプレート作成','${displayName}')`,
      },
    };
  }, {}),
};

export const MAIL_TEMPLATE_DETAIL_LABEL_COMMON_MAPPING: {
  [key: string]: string;
} = {
  backMailTop: 'メールパンくず',
  backMailTemplate: 'テンプレート管理パンくず',
  delete: 'このテンプレートを削除',
  back: 'もどる',
  copyAndCreate: 'コピーして新規作成',
  edit: '編集',
};

export const MAIL_DETAIL_LABEL_COMMON_MAPPING: {
  [key: string]: string;
} = {
  view: '詳細',
  back: 'もどる',
  backHearder: 'メールパンくず',
};

export const MAIL_TEMPLATE_DETAIL_MODAL_SPOT_EVENT_MAPPING: {
  [key: string]: GASpotEventState;
} = {
  cancel: {
    className: 'delete-modal__cancel',
    spotEvent: `_ga.spotEvent('[CREW]_クルー','テンプレート_編集','キャンセル')`,
  },
  continue: {
    className: 'delete-modal__continue',
    spotEvent: `_ga.spotEvent('[CREW]_クルー','テンプレート_編集','このまま編集する')`,
  },
};

export const MAIL_DETAIL_SPOT_EVENT_MAPPING: {
  [key: string]: GASpotEventState;
} = {
  ...Object.keys(MAIL_DETAIL_LABEL_COMMON_MAPPING).reduce((acc, cur) => {
    const displayName = MAIL_DETAIL_LABEL_COMMON_MAPPING[cur];
    const className = `mail-detail__${cur}`;
    return {
      ...acc,
      [cur]: {
        className,
        spotEvent: `_ga.spotEvent('[CREW]_クルー','メール_内容参照','${displayName}')`,
      },
    };
  }, {}),
};

export const MAIL_TEMPLATE_DETAIL_SPOT_EVENT_MAPPING: {
  [key: string]: GASpotEventState;
} = {
  ...Object.keys(MAIL_TEMPLATE_DETAIL_LABEL_COMMON_MAPPING).reduce((acc, cur) => {
    const displayName = MAIL_TEMPLATE_DETAIL_LABEL_COMMON_MAPPING[cur];
    const className = `mail-template-detail__${cur}`;
    return {
      ...acc,
      [cur]: {
        className,
        spotEvent: `_ga.spotEvent('[CREW]_クルー','テンプレート詳細','${displayName}')`,
      },
    };
  }, {}),
};

export const CUSTOMER_VIEW_MODAL_SCREEN_MAPPING: {
  [key: string]: string;
} = {
  address: '宛先選択_お客さま詳細',
  sendOne: '宛先選択_送信内容確認_お客さま詳細',
  topDetail: 'メール_内容参照_お客さま詳細',
};

export const CUSTOMER_VIEW_MODAL_SPOT_EVENT_MAPPING: {
  [key: string]: GASpotEventState;
} = {
  ...Object.keys(CUSTOMER_VIEW_MODAL_SCREEN_MAPPING).reduce((acc, cur) => {
    const screenName = CUSTOMER_VIEW_MODAL_SCREEN_MAPPING[cur];
    return {
      ...acc,
      [cur]: {
        className: 'customer-view__modal-close',
        spotEvent: `_ga.spotEvent('[CREW]_クルー','${screenName}','バツ')`,
      },
    };
  }, {}),
};

export const MAIL_CREATE_MODAL_EVENT_MAPPING: {
  [key: string]: {
    [key: string]: GASpotEventState;
  };
} = {
  ...Object.keys(MAIL_CREATE_SCREENS_MAPPING).reduce((acc, cur) => {
    const screenName = MAIL_CREATE_SCREENS_MAPPING[cur];
    return {
      ...acc,
      [cur]: Object.keys(MAIL_CREATE_MODAL_COMMON_MAPPING).reduce((subAcc, subCur) => {
        const className = `modal-create-${cur}__${subCur}`;
        const displayName = MAIL_CREATE_MODAL_COMMON_MAPPING[subCur];
        return {
          ...subAcc,
          [subCur]: {
            className,
            spotEvent: `_ga.spotEvent('[CREW]_クルー','${screenName}','${displayName}')`,
          },
        };
      }, {}),
    };
  }, {}),
};

export const ADD_CONDITION_EVENT_MAPPING: {
  [key: string]: {
    [key: string]: GASpotEventState;
  };
} = {
  ...Object.keys(ADD_CONDITION_SCREENS_MAPPING).reduce((acc, cur) => {
    const screenName = ADD_CONDITION_SCREENS_MAPPING[cur];
    return {
      ...acc,
      [cur]: Object.keys(ADD_CONDITION_BUTTON_LABEL_COMMON_MAPPING).reduce((subAcc, subCur) => {
        const className = `modal-filter-${cur}__${subCur}`;
        const displayName = ADD_CONDITION_BUTTON_LABEL_COMMON_MAPPING[subCur];
        return {
          ...subAcc,
          [subCur]: {
            className,
            spotEvent: `_ga.spotEvent('[CREW]_クルー','${screenName}','${displayName}')`,
          },
        };
      }, {}),
    };
  }, {}),
};

const SCREEN_NAME_DRAWER_NEGOTIATION = '絞り込み条件';
const SCREEN_NAME_MODAL_NEGOTIATION = '条件の追加';

export const FILTER_DRAWER_NEGOTIATION_SPOT_EVENT_MAPPING: {
  [key: string]: {
    [key: string]: GASpotEventState;
  };
} = {
  CREW: Object.keys(FILTER_DRAWER_NEGOTIATION_LABEL_COMMON_MAPPING).reduce((acc, cur) => {
    const displayName = FILTER_DRAWER_NEGOTIATION_LABEL_COMMON_MAPPING[cur];
    const className = `filter-drawer__${cur}`;
    return {
      ...acc,
      [cur]: {
        className,
        spotEvent: `_ga.spotEvent('[CREW]_クルー','${SCREEN_NAME_DRAWER_NEGOTIATION}','${displayName}')`,
      },
    };
  }, {}),

  AGENCY: Object.keys(FILTER_DRAWER_NEGOTIATION_LABEL_COMMON_MAPPING).reduce((acc, cur) => {
    const displayName = FILTER_DRAWER_NEGOTIATION_LABEL_COMMON_MAPPING[cur];
    const className = `filter-drawer__${cur}`;
    return {
      ...acc,
      [cur]: {
        className,
        spotEvent: `_ga.spotEvent('[AGENCY]_代理店','${SCREEN_NAME_DRAWER_NEGOTIATION}','${displayName}')`,
      },
    };
  }, {}),

  EMPLOYEE: Object.keys(FILTER_DRAWER_NEGOTIATION_LABEL_COMMON_MAPPING).reduce((acc, cur) => {
    const displayName = FILTER_DRAWER_NEGOTIATION_LABEL_COMMON_MAPPING[cur];
    const className = `filter-drawer__${cur}`;
    return {
      ...acc,
      [cur]: {
        className,
        spotEvent: `_ga.spotEvent('[EMPLOYEE]_営業','${SCREEN_NAME_DRAWER_NEGOTIATION}','${displayName}')`,
      },
    };
  }, {}),
};

export const ADD_CONDITION_NEGOTIATION_SPOT_EVENT_MAPPING: {
  [key: string]: {
    [key: string]: GASpotEventState;
  };
} = {
  CREW: Object.keys(ADD_CONDITION_NEGOTIATION_LABEL_COMMON_MAPPING).reduce((acc, cur) => {
    const displayName = ADD_CONDITION_NEGOTIATION_LABEL_COMMON_MAPPING[cur];
    const className = `filter-modal__${cur}`;
    return {
      ...acc,
      [cur]: {
        className,
        spotEvent: `_ga.spotEvent('[CREW]_クルー','${SCREEN_NAME_MODAL_NEGOTIATION}','${displayName}')`,
      },
    };
  }, {}),

  AGENCY: Object.keys(ADD_CONDITION_NEGOTIATION_LABEL_COMMON_MAPPING).reduce((acc, cur) => {
    const displayName = ADD_CONDITION_NEGOTIATION_LABEL_COMMON_MAPPING[cur];
    const className = `filter-modal__${cur}`;
    return {
      ...acc,
      [cur]: {
        className,
        spotEvent: `_ga.spotEvent('[AGENCY]_代理店','${SCREEN_NAME_MODAL_NEGOTIATION}','${displayName}')`,
      },
    };
  }, {}),

  EMPLOYEE: Object.keys(ADD_CONDITION_NEGOTIATION_LABEL_COMMON_MAPPING).reduce((acc, cur) => {
    const displayName = ADD_CONDITION_NEGOTIATION_LABEL_COMMON_MAPPING[cur];
    const className = `filter-modal__${cur}`;
    return {
      ...acc,
      [cur]: {
        className,
        spotEvent: `_ga.spotEvent('[EMPLOYEE]_営業','${SCREEN_NAME_MODAL_NEGOTIATION}','${displayName}')`,
      },
    };
  }, {}),
};

export const DRAWER_SPOT_EVENT_MAPPING: {
  [key: string]: {
    [key: string]: GASpotEventState;
  };
} = {
  ...Object.keys(FILTER_MAIL_SCREENS_MAPPING).reduce((acc, cur) => {
    const screenName = FILTER_MAIL_SCREENS_MAPPING[cur];
    return {
      ...acc,
      [cur]: Object.keys(DRAWER_FULL_LABEL_COMMON_MAPPING).reduce((subAcc, subCur) => {
        const className = `filter-drawer-${cur}__${subCur}`;
        const displayName = DRAWER_FULL_LABEL_COMMON_MAPPING[subCur];
        return {
          ...subAcc,
          [subCur]: {
            className,
            spotEvent: `_ga.spotEvent('[CREW]_クルー','${screenName}','${displayName}')`,
          },
        };
      }, {}),
    };
  }, {}),
};

export const FILTER_DRAWER_SPOT_EVENT_COMMON_MAPPING: {
  [key: string]: {
    [key: string]: {
      [key: string]: GASpotEventState;
    };
  };
} = {
  CREW: {
    [FILTER_SECTIONS_KEY.DRAWER]: FILTER_DRAWER_NEGOTIATION_SPOT_EVENT_MAPPING['CREW'],
    [FILTER_SECTIONS_KEY.MODAL]: ADD_CONDITION_NEGOTIATION_SPOT_EVENT_MAPPING['CREW'],
  },
  AGENCY: {
    [FILTER_SECTIONS_KEY.DRAWER]: FILTER_DRAWER_NEGOTIATION_SPOT_EVENT_MAPPING['AGENCY'],
    [FILTER_SECTIONS_KEY.MODAL]: ADD_CONDITION_NEGOTIATION_SPOT_EVENT_MAPPING['AGENCY'],
  },
  EMPLOYEE: {
    [FILTER_SECTIONS_KEY.DRAWER]: FILTER_DRAWER_NEGOTIATION_SPOT_EVENT_MAPPING['EMPLOYEE'],
    [FILTER_SECTIONS_KEY.MODAL]: ADD_CONDITION_NEGOTIATION_SPOT_EVENT_MAPPING['EMPLOYEE'],
  },
  MAIL: {
    [FILTER_SECTIONS_KEY.DRAWER]: DRAWER_SPOT_EVENT_MAPPING['address'],
    [FILTER_SECTIONS_KEY.MODAL]: ADD_CONDITION_EVENT_MAPPING['address'],
  },
};

export const MAIL_ADDRESS_SPOT_EVENT_MAPPING: {
  [key: string]: GASpotEventState;
} = {
  ...Object.keys(MAIL_ADDRESS_LABEL_COMMON_MAPPING).reduce((acc, cur) => {
    const displayName = MAIL_ADDRESS_LABEL_COMMON_MAPPING[cur];
    const className = cur === REFRESH_BTN_COMMON.KEY ? REFRESH_BTN_COMMON.CLASSNAME : `mail-address__${cur}`;
    return {
      ...acc,
      [cur]: {
        className,
        spotEvent: `_ga.spotEvent('[CREW]_クルー','${SCREEN.MAIL_ADDRESS_SELECT.NAME}','${displayName}')`,
      },
    };
  }, {}),
};

export const MAIL_TOP_SPOT_EVENT_MAPPING: {
  [key: string]: GASpotEventState;
} = {
  ...Object.keys(MAIL_TOP_LABEL_COMMON_MAPPING).reduce((acc, cur) => {
    const displayName = MAIL_TOP_LABEL_COMMON_MAPPING[cur];
    const className = cur === REFRESH_BTN_COMMON.KEY ? REFRESH_BTN_COMMON.CLASSNAME : `mail-top__${cur}`;
    return {
      ...acc,
      [cur]: {
        className,
        spotEvent: `_ga.spotEvent('[CREW]_クルー','${SCREEN.MAIL_TOP.NAME}','${displayName}')`,
      },
    };
  }, {}),
};

export const MAIL_TEMPLATE_SPOT_EVENT_MAPPING: {
  [key: string]: GASpotEventState;
} = {
  ...Object.keys(MAIL_TEMPLATE_LABEL_COMMON_MAPPING).reduce((acc, cur) => {
    const displayName = MAIL_TEMPLATE_LABEL_COMMON_MAPPING[cur];
    const className = cur === REFRESH_BTN_COMMON.KEY ? REFRESH_BTN_COMMON.CLASSNAME : `mail-template__${cur}`;
    return {
      ...acc,
      [cur]: {
        className,
        spotEvent: `_ga.spotEvent('[CREW]_クルー','${SCREEN.MAIL_TEMPLATE_LIST.NAME}','${displayName}')`,
      },
    };
  }, {}),
};

export const MAIL_FORM_BUTTON_LABEL_COMMON_MAPPING: {
  [key: string]: string;
} = {
  cancel: 'キャンセル',
  draft: '下書き保存',
  add: '宛先選択',
  back: 'メールへもどる',
  delete: 'この下書きを削除',
};

export const MAIL_FORM_MAPPING: {
  [key: string]: string;
} = {
  oneCreate: '個別送信',
  multiCreate: '一斉送信',
  oneEdit: 'メール_個別内容編集',
  multiEdit: 'メール_一斉内容編集',
};

export const MAIL_FORM_SPOT_EVENT_MAPPING: {
  [key: string]: {
    [key: string]: GASpotEventState;
  };
} = {
  ...Object.keys(MAIL_FORM_MAPPING).reduce((acc, cur) => {
    const screenName = MAIL_FORM_MAPPING[cur];
    return {
      ...acc,
      [cur]: Object.keys(MAIL_FORM_BUTTON_LABEL_COMMON_MAPPING).reduce((subAcc, subCur) => {
        const className = `mail-form__${subCur}`;
        const displayName = MAIL_FORM_BUTTON_LABEL_COMMON_MAPPING[subCur];
        return {
          ...subAcc,
          [subCur]: {
            className,
            spotEvent: `_ga.spotEvent('[CREW]_クルー','${screenName}','${displayName}')`,
          },
        };
      }, {}),
    };
  }, {}),
};

export const HEARING_MODAL_BUTTON_LABEL_MAPPING: {
  [key: string]: string;
} = {
  close: 'バツ',
  cancel: '閉じる',
};

const HEARING_MODAL: {
  [key: string]: string;
} = {
  label: 'ヒアリング回答',
  prefixClassName: 'hearing-modal__td',
};

const VISIT_TAB_MAPPING: {
  [key: string]: { [key: string]: string };
} = SCREEN.VISIT.TAB_LIST.reduce((acc, cur) => {
  const { type, title } = cur;
  return {
    ...acc,
    [type]: {
      displayName: title,
      className: `visit-tabs__${type}`,
    },
  };
}, {});

const COL_INFO_NUMBER_VISIT_LIST: {
  [key: string]: string;
} = {
  className: 'visit-reservation-text__code',
  label: `${SCREEN.VISIT.NAME}_予約一覧`,
  displayName: '案内番号',
};

export const VISIT_SUMMARY_SPOT_EVENT_MAPPING: {
  [key: string]: {
    [key: string]: GASpotEventState | { [key: string]: GASpotEventState };
  };
} = {
  CREW: {
    visitTab: Object.keys(VISIT_TAB_MAPPING).reduce((acc, cur) => {
      const { displayName, className } = VISIT_TAB_MAPPING[cur];
      return {
        ...acc,
        [cur]: {
          className,
          spotEvent: `_ga.spotEvent('[CREW]_クルー','${SCREEN.VISIT.NAME}','${displayName}')`,
        },
      };
    }, {}),
    [REFRESH_BTN_COMMON.KEY]: REFRESH_SPOT_EVENT_MAPPING['CREW'][SCREEN_REFRESH_KEY_COMMON.visitSummary],
    infoNumber: {
      className: COL_INFO_NUMBER_VISIT_LIST.className,
      spotEvent: `_ga.spotEvent('[CREW]_クルー','${COL_INFO_NUMBER_VISIT_LIST.label}','${COL_INFO_NUMBER_VISIT_LIST.displayName}')`,
    },
  },
  AGENCY: {
    visitTab: Object.keys(VISIT_TAB_MAPPING).reduce((acc, cur) => {
      const { displayName, className } = VISIT_TAB_MAPPING[cur];
      return {
        ...acc,
        [cur]: {
          className,
          spotEvent: `_ga.spotEvent('[AGENCY]_代理店','${SCREEN.VISIT.NAME}','${displayName}')`,
        },
      };
    }, {}),
    [REFRESH_BTN_COMMON.KEY]: REFRESH_SPOT_EVENT_MAPPING['AGENCY'][SCREEN_REFRESH_KEY_COMMON.visitSummary],
    infoNumber: {
      className: COL_INFO_NUMBER_VISIT_LIST.className,
      spotEvent: `_ga.spotEvent('[AGENCY]_代理店','${COL_INFO_NUMBER_VISIT_LIST.label}','${COL_INFO_NUMBER_VISIT_LIST.displayName}')`,
    },
  },
  EMPLOYEE: {
    visitTab: Object.keys(VISIT_TAB_MAPPING).reduce((acc, cur) => {
      const { displayName, className } = VISIT_TAB_MAPPING[cur];
      return {
        ...acc,
        [cur]: {
          className,
          spotEvent: `_ga.spotEvent('[EMPLOYEE]_営業','${SCREEN.VISIT.NAME}','${displayName}')`,
        },
      };
    }, {}),
    [REFRESH_BTN_COMMON.KEY]: REFRESH_SPOT_EVENT_MAPPING['EMPLOYEE'][SCREEN_REFRESH_KEY_COMMON.visitSummary],
    infoNumber: {
      className: COL_INFO_NUMBER_VISIT_LIST.className,
      spotEvent: `_ga.spotEvent('[EMPLOYEE]_営業','${COL_INFO_NUMBER_VISIT_LIST.label}','${COL_INFO_NUMBER_VISIT_LIST.displayName}')`,
    },
  },
};

export const HEARING_MODAL_SPOT_EVENT_MAPPING: {
  [key: string]: {
    [key: string]: GASpotEventState;
  };
} = {
  CREW: Object.keys(HEARING_MODAL_BUTTON_LABEL_MAPPING).reduce((acc, cur) => {
    const displayName = HEARING_MODAL_BUTTON_LABEL_MAPPING[cur];
    const className = `${HEARING_MODAL.prefixClassName}-${cur}`;
    return {
      ...acc,
      [cur]: {
        className,
        spotEvent: `_ga.spotEvent('[CREW]_クルー','${HEARING_MODAL.label}','${displayName}')`,
      },
    };
  }, {}),
  AGENCY: Object.keys(HEARING_MODAL_BUTTON_LABEL_MAPPING).reduce((acc, cur) => {
    const displayName = HEARING_MODAL_BUTTON_LABEL_MAPPING[cur];
    const className = `${HEARING_MODAL.prefixClassName}-${cur}`;
    return {
      ...acc,
      [cur]: {
        className,
        spotEvent: `_ga.spotEvent('[AGENCY]_代理店','${HEARING_MODAL.label}','${displayName}')`,
      },
    };
  }, {}),
  EMPLOYEE: Object.keys(HEARING_MODAL_BUTTON_LABEL_MAPPING).reduce((acc, cur) => {
    const displayName = HEARING_MODAL_BUTTON_LABEL_MAPPING[cur];
    const className = `${HEARING_MODAL.prefixClassName}-${cur}`;
    return {
      ...acc,
      [cur]: {
        className,
        spotEvent: `_ga.spotEvent('[EMPLOYEE]_営業','${HEARING_MODAL.label}','${displayName}')`,
      },
    };
  }, {}),
};
/** -------------------------------------------------
 * PCM-I-4211-6 TDタグ対応（8月分）
 * --------------------------------------------------*/

export const KEPT_SEARCH_CONDITION_NAMES: { [key: string]: boolean } = {
  keyword: true,
  createDate: true,
  latestUpdateDate: true,
  actionDate: true,
  [SALE_MANCD_NAME_KEY.CLOSING_SALE_MANCD]: true,
  [SALE_MANCD_NAME_KEY.MAIN_CLOSING_SALE_MANCD]: true,
};

export const SIDE_NAV_ICON: { [key: string]: string } = {
  LINKED_DATA_RESULT: 'linked_data_icon',
  SEARCH: 'list_bulleted',
  CUSTOMER_INFO_LIST: 'group',
};
/**
 * option/radio系の未選択状態の共通初期値(displayItemIdで管理されるもの)予定
 * *[現状] Componentに'00'をベタ書きしている箇所が多い
 */
export const INITIAL_VALUE_TO_SELECTION = '00';

/**
 * Generates a random UUID-like string using CryptoJS.
 * @returns {string} A randomly generated hexadecimal string of 32 characters.
 */
export const randomUUID = (): string => {
  const randomBytes = CryptoJS.lib.WordArray.random(16);
  return randomBytes.toString(CryptoJS.enc.Hex);
};

export const TOSSUP_STATUS_CODE = {
  // 未実施 or 対象外
  EXCLUDED: 'excluded',
  /**
   * 未受取
   */
  UNRECEIVED: 'unreceived',
  /**
   * 受取済
   */
  RECEIVED: 'received',
} as const;
export type TossupStatusType = typeof TOSSUP_STATUS_CODE[keyof typeof TOSSUP_STATUS_CODE];
export const FREEWORD_SEARCH_MAPPING: {
  [key: string]: {
    [key: string]: string;
  };
} = {
  NEGOTIATION: {
    FULL: 'commonlyUsedFieldFilterKeyword',
    CUSTOMER_NUMBER_ONLY: 'customerNumberFilterKeyword',
    CUSTOMER_NAME_ONLY: 'customerNameFilterKeyword',
  },
  MAIL: {
    FULL: 'keyword',
    CUSTOMER_NUMBER_ONLY: 'customerNumberFilterKeyword',
    CUSTOMER_NAME_ONLY: 'nameFilterKeyword',
  },
};
